var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g, _path54, _path55, _g2, _g3, _g4, _g5, _g6, _g7, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "140.9px",
    height: "140px",
    viewBox: "0 0 140.9 140",
    style: {
      enableBackground: "new 0 0 140.9 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill:url(#SVGID_17_);}\n\t.st17{fill:url(#SVGID_18_);}\n\t.st18{fill:url(#SVGID_19_);}\n\t.st19{fill:url(#SVGID_20_);}\n\t.st20{fill:url(#SVGID_21_);}\n\t.st21{fill:url(#SVGID_22_);}\n\t.st22{fill:url(#SVGID_23_);}\n\t.st23{fill:url(#SVGID_24_);}\n\t.st24{fill:url(#SVGID_25_);}\n\t.st25{fill:url(#SVGID_26_);}\n\t.st26{fill:url(#SVGID_27_);}\n\t.st27{fill:url(#SVGID_28_);}\n\t.st28{fill:url(#SVGID_29_);}\n\t.st29{fill:url(#SVGID_30_);}\n\t.st30{fill:url(#SVGID_31_);}\n\t.st31{fill:url(#SVGID_32_);}\n\t.st32{fill:url(#SVGID_33_);}\n\t.st33{fill:url(#SVGID_34_);}\n\t.st34{fill:url(#SVGID_35_);}\n\t.st35{fill:url(#SVGID_36_);}\n\t.st36{fill:url(#SVGID_37_);}\n\t.st37{fill:#BCBCBC;}\n\t.st38{fill:#898989;}\n\t.st39{fill:url(#SVGID_38_);}\n\t.st40{fill:url(#SVGID_39_);}\n\t.st41{fill:url(#SVGID_40_);}\n\t.st42{fill:#CECECE;}\n\t.st43{fill:url(#SVGID_41_);}\n\t.st44{fill:url(#SVGID_42_);}\n\t.st45{fill:#757575;}\n\t.st46{fill:#A0A0A0;}\n\t.st47{opacity:0.29;}\n\t.st48{opacity:0;}\n\t.st49{opacity:9.090900e-02;}\n\t.st50{opacity:0.1818;}\n\t.st51{opacity:0.2727;}\n\t.st52{opacity:0.3636;}\n\t.st53{opacity:0.4545;}\n\t.st54{opacity:0.5455;}\n\t.st55{opacity:0.6364;}\n\t.st56{opacity:0.7273;}\n\t.st57{opacity:0.8182;}\n\t.st58{opacity:0.9091;}\n\t.st59{opacity:0.62;}\n\t.st60{opacity:0.53;}\n\t.st61{opacity:0.39;}\n\t.st62{opacity:0;fill:#FFFFFF;}\n\t.st63{opacity:9.090900e-02;fill:#FFFFFF;}\n\t.st64{opacity:0.1818;fill:#FFFFFF;}\n\t.st65{opacity:0.2727;fill:#FFFFFF;}\n\t.st66{opacity:0.3636;fill:#FFFFFF;}\n\t.st67{opacity:0.4545;fill:#FFFFFF;}\n\t.st68{opacity:0.5455;fill:#FFFFFF;}\n\t.st69{opacity:0.6364;fill:#FFFFFF;}\n\t.st70{opacity:0.7273;fill:#FFFFFF;}\n\t.st71{opacity:0.8182;fill:#FFFFFF;}\n\t.st72{opacity:0.9091;fill:#FFFFFF;}\n\t.st73{fill:#FFFFFF;}\n\t.st74{fill:url(#SVGID_43_);}\n\t.st75{fill:url(#SVGID_44_);}\n\t.st76{fill:url(#SVGID_45_);}\n\t.st77{fill:url(#SVGID_46_);}\n\t.st78{fill:url(#SVGID_47_);}\n\t.st79{fill:url(#SVGID_48_);}\n\t.st80{fill:#606060;}\n\t.st81{fill:url(#SVGID_49_);}\n\t.st82{fill:url(#SVGID_50_);}\n\t.st83{fill:url(#SVGID_51_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.2916,
    y1: 95.7279,
    x2: 113.2916,
    y2: 39.9608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#838383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.3,113.1c0,0,0,0.1,0,0.1h0l-1.8-1.1c0.4-2.9,0.8-5.8,1.2-8.7c0.4-2.9,0.8-5.9,1.2-8.8 c0.1-0.7,0.2-1.4,0.3-2.1c0.1-0.7,0.2-1.4,0.3-2.1c0.1-0.8,0.6-1.6,1.2-2.2c0.5-0.5,1-0.8,1.6-1.1c-0.7,4.8-1.5,9.6-2.2,14.4 c0,0,0,0,0,0c-0.2,0.9-0.4,1.8-0.6,2.6c-0.2,0.9-0.5,1.7-0.2,2.7c-0.2,1.4-0.4,2.8-0.6,4.1C112.5,111.8,112.4,112.5,112.3,113.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.8938,
    y1: 95.7275,
    x2: 95.8938,
    y2: 39.9573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#838383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.3,99.2c-0.1,1.7-0.3,3.5-0.4,5.2l-2.4-1.4c0-0.3,0-0.6,0.1-0.9c0.1-0.9,0.2-1.4,0.7-2.1 c0.2-0.4,0.5-0.7,0.8-1c0.2-0.2,0.4-0.3,0.6-0.4c0.2,0.2,0.4,0.4,0.6,0.5L97.3,99.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.1941,
    y1: 95.7278,
    x2: 104.1941,
    y2: 39.959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#838383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.7,93.4c-0.3,1.8-0.7,3.6-1,5.4c-0.1,0.5-0.2,0.9-0.2,1.4c-0.1,0.5-0.2,0.9-0.1,1.4 c0.1,0.9,0.5,1.8,1.2,2.4l-0.6,5.2l-2.3-1.3c0.4-3.9,0.9-7.7,1.3-11.6c0.1-0.8,0.6-1.7,1.2-2.3C105.3,93.7,105.5,93.5,105.7,93.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.3628,
    y1: 102.8093,
    x2: 20.3628,
    y2: 69.3079
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06841779,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    style: {
      stopColor: "#7E7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    style: {
      stopColor: "#8D8D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6629,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.8,101.2c0.1,0.5,0.3,1.4-0.4,1.6c-0.4,0.1-0.7,0-1-0.2c-0.4-0.2-0.8-0.4-1.1-0.7c-0.7-0.5-1.2-1.3-1.6-2 c-0.2-0.4-0.5-1.7-0.6-2.1c-0.3-1.4-0.7-2.8-1-4.2c-0.7-3-1.4-5.9-2.1-8.9c-0.7-3-1.4-5.9-2.1-8.9c-0.4-1.6-0.8-3.2-1.1-4.9 c-0.1-0.5-0.3-1.4,0.5-1.5c0.4-0.1,0.7,0.1,1,0.3c0.1,0.1,0.3,0.2,0.4,0.2c1.3,5.3,2.5,10.7,3.8,16c0.6,2.7,1.3,5.3,1.9,8 c0.3,1.3,0.6,2.7,0.9,4c0.2,0.7,0.4,1.3,0.9,1.8c0.2,0.3,0.5,0.5,0.7,0.8c0.2,0.2,0.4,0.3,0.6,0.4c0.1,0,0.1,0.1,0.2,0.1 C25.8,101,25.8,101.1,25.8,101.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5247,
    y1: 107.8517,
    x2: 29.5247,
    y2: 74.8428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06841779,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    style: {
      stopColor: "#7E7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    style: {
      stopColor: "#8D8D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6629,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.6,106.3c0.1,0.4,0.2,0.7,0.1,1.1c-0.2,0.7-1,0.5-1.5,0.2c-0.8-0.5-1.2-0.7-1.9-1.4 c-0.3-0.3-0.5-0.7-0.7-1.1c-0.2-0.3-0.2-0.7-0.3-1.1c-0.3-1.4-0.6-2.8-0.9-4.1c-0.6-2.9-1.2-5.9-1.9-8.8c-0.6-2.9-1.2-5.9-1.9-8.8 c-0.3-1.6-0.7-3.2-1-4.8c-0.1-0.4-0.2-0.8-0.3-1.2c-0.1-0.3-0.2-0.7,0-1c0.3-0.7,1.1-0.4,1.6-0.1c0.1,0.1,0.2,0.1,0.3,0.2v0 c0.3,1.4,0.6,2.8,0.9,4.2c0,0,0,0,0,0c0.8,3.8,1.6,7.7,2.4,11.5c0,0.1,0,0.2,0.1,0.3c0.1,0.5,0.2,0.9,0.3,1.4 c0.3,1.6,0.7,3.3,1,4.9h0c0.1,0.4,0.2,0.8,0.3,1.3c0.3,1.3,0.6,2.6,0.8,3.9c0.1,0.7,0.5,1.3,0.9,1.8c0.2,0.3,0.5,0.5,0.7,0.8 c0.2,0.2,0.5,0.4,0.8,0.5h0C34.6,106.1,34.6,106.2,34.6,106.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.6477,
    y1: 112.8829,
    x2: 38.6477,
    y2: 80.3455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06841779,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    style: {
      stopColor: "#7E7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    style: {
      stopColor: "#8D8D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6629,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M35.8,80.8c0.8,4.2,1.6,8.5,2.4,12.7c0.2,0.9,0.3,1.9,0.5,2.8c0.5,2.6,1,5.2,1.4,7.8c0.1,0.6,0.2,1.3,0.4,1.9 c0.1,0.6,0.2,1.3,0.4,1.9c0.2,0.7,0.5,1.2,0.9,1.8c0.2,0.3,0.5,0.5,0.7,0.7c0.2,0.2,0.5,0.3,0.8,0.5c0,0.1,0,0.2,0.1,0.3 c0.1,0.3,0.2,0.7,0,1c-0.2,0.7-1,0.5-1.5,0.2c-0.8-0.5-1.2-0.7-1.8-1.4c-0.5-0.6-0.8-1.3-1-2.1c-0.3-1.3-0.5-2.7-0.8-4 c-0.5-2.9-1.1-5.8-1.6-8.7c-0.5-2.9-1.1-5.8-1.6-8.7c-0.3-1.6-0.6-3.1-0.9-4.7c-0.1-0.4-0.1-0.8-0.2-1.2c-0.1-0.3-0.1-0.6,0-1 c0.3-0.7,1.1-0.4,1.6-0.1C35.6,80.7,35.7,80.8,35.8,80.8L35.8,80.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.734,
    y1: 117.9039,
    x2: 47.734,
    y2: 85.8164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06841779,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    style: {
      stopColor: "#7E7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    style: {
      stopColor: "#8D8D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6629,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M52,116.1c0.1,0.5,0.2,1.1,0,1.5c-0.3,0.6-1,0.4-1.5,0.1c-0.7-0.4-1.4-0.8-2-1.4c-0.6-0.6-1.1-1.4-1.2-2.3 c-0.8-5.7-1.7-11.5-2.5-17.2c-0.4-2.9-0.8-5.7-1.3-8.6c-0.1-0.4-0.3-1.5-0.1-2c0.3-0.6,1-0.4,1.5-0.1c0.1,0.1,0.2,0.1,0.4,0.2v0 l0.4,3l3.4,23.4c0.1,0.7,0.6,1.5,1,2.1C50.8,115.4,51.2,115.6,52,116.1L52,116.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.6173,
    y1: 122.6805,
    x2: 56.6173,
    y2: 91.2869
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06841779,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    style: {
      stopColor: "#7E7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    style: {
      stopColor: "#8D8D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6629,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.3,120.9c0,0.3,0.1,0.7,0.1,1c0,0.3-0.1,0.5-0.3,0.7c-0.3,0.2-0.6,0.1-0.8,0c-0.4-0.1-0.7-0.4-1.1-0.6 c-0.7-0.4-1.3-1.1-1.7-1.8c-0.4-0.8-0.4-1.2-0.5-2c-0.2-1.3-0.3-2.6-0.5-3.9c-0.3-2.8-0.7-5.6-1-8.4c-0.3-2.8-0.7-5.6-1-8.4 c-0.2-1.5-0.3-3-0.5-4.5c-0.1-0.4-0.3-1.4,0.3-1.7c0.3-0.1,0.6-0.1,0.9,0c0.2,0.1,0.4,0.2,0.6,0.3v0l0,0c0.6,4.9,1.2,9.9,1.7,14.8 c0.3,2.5,0.6,4.9,0.9,7.4c0.1,0.6,0.1,1.2,0.2,1.9c0.1,0.6,0.1,1.2,0.2,1.9c0.2,1.1,1.2,2.4,2.1,3L60.3,120.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.738,
    y1: 127.715,
    x2: 65.738,
    y2: 96.7836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06841779,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    style: {
      stopColor: "#7E7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    style: {
      stopColor: "#8D8D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6629,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M69,125.9c0,0.3,0.1,0.7,0.1,1c0,0.3-0.1,0.5-0.3,0.7c-0.3,0.2-0.6,0.1-0.8,0c-0.4-0.1-0.7-0.4-1.1-0.6 c-0.7-0.4-1.3-1.1-1.7-1.8c-0.4-0.8-0.4-1.1-0.5-2c-0.1-1.3-0.2-2.5-0.3-3.8c-0.2-2.8-0.5-5.5-0.7-8.3c-0.2-2.8-0.5-5.5-0.7-8.3 c-0.1-1.5-0.3-2.9-0.4-4.4c0-0.4-0.3-1.4,0.3-1.7c0.3-0.1,0.6-0.1,0.9,0.1c0.2,0.1,0.4,0.2,0.6,0.3l0,0c0.4,4.9,0.9,9.7,1.3,14.6 c0.2,2.4,0.4,4.9,0.7,7.3c0.1,0.6,0.1,1.2,0.2,1.8c0,0.2,0.1,1.7,0.2,1.8c0.2,1.1,1.2,2.3,2.1,2.9L69,125.9L69,125.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.9035,
    y1: 132.7725,
    x2: 74.9035,
    y2: 102.3188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06841779,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    style: {
      stopColor: "#7E7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    style: {
      stopColor: "#8D8D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6629,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M77.8,131c0,0.5,0,1.1,0,1.2c-0.2,0.7-0.9,0.6-1.4,0.3c-0.7-0.4-1.3-0.7-1.8-1.3c-0.5-0.6-0.9-1.3-1.1-2 c0-0.2-0.1-1.6-0.1-1.8c0-0.6-0.1-1.2-0.1-1.8c-0.2-2.7-0.3-5.5-0.5-8.2c-0.2-2.7-0.3-5.5-0.5-8.2c-0.1-1.4-0.2-2.9-0.3-4.3 c0-0.3-0.1-1.8,0-2.1c0.2-0.7,1-0.5,1.5-0.2c0.1,0.1,0.2,0.1,0.3,0.2v0c0.3,4.9,0.6,9.8,0.9,14.6c0.1,2.4,0.3,4.9,0.4,7.3 c0,0.6,0.1,1.2,0.1,1.8c0,0.6,0,1.2,0.2,1.8c0.2,0.6,0.6,1.1,1,1.6C76.9,130.5,77.2,130.6,77.8,131L77.8,131z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.7925,
    y1: 119.9341,
    x2: 113.7925,
    y2: 86.8576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06841779,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    style: {
      stopColor: "#7E7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    style: {
      stopColor: "#8D8D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6629,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M118,87.3c0.2,0.4,0.1,0.7,0,1c-0.1,0.4-0.1,0.8-0.2,1.2c-0.2,1.6-0.5,3.2-0.7,4.8c-0.4,2.9-0.9,5.9-1.3,8.8 c-0.4,2.9-0.9,5.9-1.3,8.8c-0.2,1.4-0.4,2.8-0.6,4.2c-0.1,0.8-0.4,1.5-0.9,2.2c-0.6,0.8-1,1-1.8,1.4c-0.5,0.3-1.3,0.5-1.5-0.2 c-0.1-0.4-0.1-0.7,0-1.1c0-0.1,0-0.1,0-0.2c0.7-0.4,1-0.6,1.5-1.2c0.4-0.6,0.8-1.1,0.9-1.8c0.1-0.6,0.2-1.2,0.3-1.8 c0,0,0-0.1,0-0.1c0.1-0.7,0.2-1.3,0.3-2c0.2-1.4,0.4-2.8,0.6-4.1c0.2-1.3,0.4-2.5,0.6-3.8c0.1-0.5,0.1-1,0.2-1.5c0,0,0,0,0,0 c0.7-4.8,1.5-9.6,2.2-14.4c0.1,0,0.2-0.1,0.2-0.1C116.9,86.9,117.7,86.6,118,87.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.7866,
    y1: 124.9115,
    x2: 104.7866,
    y2: 92.2799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06841779,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    style: {
      stopColor: "#7E7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    style: {
      stopColor: "#8D8D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6629,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M105.6,103.9l1.3-11.2l0,0c0.1-0.1,0.2-0.1,0.3-0.2c0.5-0.3,1.2-0.4,1.5,0.2c0.2,0.5,0,1.6-0.1,2 c-0.3,2.9-0.7,5.8-1,8.8c-0.7,5.8-1.3,11.7-2,17.5c-0.1,0.8-0.6,1.7-1.2,2.3c-0.6,0.6-1.3,1-2,1.4c-0.5,0.3-1.2,0.4-1.5-0.2 c-0.1-0.3-0.1-0.8,0-1.3h0c0.8-0.5,1.2-0.6,1.9-1.4c0.5-0.6,0.9-1.4,1-2.1l1.2-10.6L105.6,103.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.9805,
    y1: 129.6483,
    x2: 95.9805,
    y2: 97.7009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06841779,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    style: {
      stopColor: "#7E7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    style: {
      stopColor: "#8D8D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6629,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M98.8,97.8c0.6,0.3,0.4,1.3,0.4,1.7c-0.1,1.5-0.3,3-0.4,4.5c-0.2,2.8-0.5,5.7-0.7,8.5 c-0.2,2.8-0.5,5.7-0.7,8.5c-0.1,1.3-0.2,2.6-0.3,4c-0.1,0.9-0.1,1.3-0.5,2.1c-0.4,0.7-0.9,1.4-1.6,1.8c-0.4,0.2-1.3,0.9-1.9,0.5 c-0.3-0.2-0.3-0.4-0.4-0.7c0-0.3,0-0.6,0-0.9h0l0.4-0.2c1-0.6,1.9-1.9,2-3.1c0.1-1.3,0.2-2.5,0.3-3.8c0.2-2.5,0.4-5,0.6-7.6 c0.2-3,0.5-5.9,0.7-8.9c0.1-1.7,0.3-3.5,0.4-5.2c0-0.4,0.1-0.7,0.1-1.1l0,0c0.2-0.1,0.4-0.2,0.6-0.3 C98.3,97.7,98.5,97.6,98.8,97.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.7928,
    y1: 118.328,
    x2: 32.7928,
    y2: 91.207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M34.4,105.1c0.1,0.3,0.1,0.6,0.2,0.9h0c-0.3-0.2-0.5-0.3-0.8-0.5c-0.3-0.2-0.5-0.5-0.7-0.8 c-0.4-0.5-0.7-1.1-0.9-1.8c-0.3-1.3-0.6-2.6-0.8-3.9c-0.1-0.4-0.2-0.9-0.3-1.3l1.7-1c0.2,1.2,0.5,2.4,0.7,3.6 C33.7,101.9,34.1,103.5,34.4,105.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.7346,
    y1: 118.3278,
    x2: 40.7346,
    y2: 91.2072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M43.1,110.2c0,0.3,0.1,0.6,0.1,0.9c-0.3-0.2-0.5-0.3-0.8-0.5c-0.3-0.2-0.5-0.5-0.7-0.7 c-0.4-0.5-0.8-1.1-0.9-1.8c-0.1-0.6-0.2-1.3-0.4-1.9c-0.1-0.6-0.2-1.3-0.4-1.9c-0.5-2.6-1-5.2-1.4-7.8c-0.2-0.9-0.3-1.9-0.5-2.8 l1.9-1.1c0.2,1.4,0.5,2.9,0.7,4.3c0.5,2.9,1,5.8,1.5,8.7C42.6,107,42.9,108.6,43.1,110.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.854,
    y1: 118.3283,
    x2: 48.854,
    y2: 91.207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M50.7,107c0.4,2.9,0.8,5.7,1.3,8.6c0,0.1,0.1,0.3,0.1,0.5l0,0c-0.8-0.5-1.2-0.6-1.9-1.4 c-0.5-0.6-0.9-1.3-1-2.1l-3.4-23.4l1.8-1c0.3,0.5,0.6,1,0.6,1.5C49,95.5,49.8,101.2,50.7,107z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.5233,
    y1: 118.3282,
    x2: 57.5233,
    y2: 91.2069
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M60.3,120.8C60.3,120.8,60.3,120.8,60.3,120.8l-0.4-0.1c-1-0.6-1.9-1.9-2.1-3c-0.1-0.6-0.1-1.2-0.2-1.9 c-0.1-0.6-0.1-1.2-0.2-1.9c-0.3-2.5-0.6-4.9-0.9-7.4c-0.6-4.9-1.2-9.9-1.7-14.8l0,0c0.1,0.1,0.3,0.2,0.4,0.3 c0.8,0.5,1.2,0.8,1.8,1.6c0.5,0.7,0.6,1.2,0.7,2.1c0.1,1.3,0.3,2.6,0.4,3.8c0.3,2.8,0.6,5.6,0.9,8.4c0.3,2.8,0.6,5.6,0.9,8.4 C60,117.8,60.1,119.3,60.3,120.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.6448,
    y1: 118.328,
    x2: 66.6448,
    y2: 91.2071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M69,125.9C69,125.9,69,125.9,69,125.9L69,125.9l-0.4-0.2c-0.9-0.5-1.9-1.8-2.1-2.9c0-0.2-0.2-1.7-0.2-1.8 c-0.1-0.6-0.1-1.2-0.2-1.8c-0.2-2.4-0.4-4.9-0.7-7.3c-0.4-4.9-0.9-9.7-1.3-14.6l0,0c0.2,0.1,0.3,0.2,0.5,0.3 c0.3,0.2,0.6,0.4,0.9,0.6c0.3,0.3,0.6,0.6,0.8,1c0.5,0.7,0.6,1.2,0.7,2c0.1,1.2,0.2,2.5,0.3,3.7c0.2,2.8,0.4,5.5,0.6,8.3 c0.2,2.8,0.4,5.5,0.6,8.3C68.8,123,68.9,124.4,69,125.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.8098,
    y1: 118.3281,
    x2: 75.8098,
    y2: 91.2069
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M77.8,130.1c0,0.1,0,0.5,0,0.9h0c-0.6-0.4-0.9-0.5-1.4-1.1c-0.4-0.5-0.8-1-1-1.6c-0.2-0.6-0.2-1.2-0.2-1.8 c0-0.6-0.1-1.2-0.1-1.8c-0.1-2.4-0.3-4.9-0.4-7.3c-0.3-4.9-0.6-9.8-0.9-14.6v0c0.5,0.3,1.1,0.6,1.5,1c0.6,0.6,1,1.2,1.3,2 c0.2,0.6,0.1,1.2,0.2,1.8c0,0.6,0.1,1.2,0.1,1.8c0.1,2.7,0.2,5.5,0.4,8.2c0.1,2.7,0.2,5.5,0.4,8.2 C77.7,127.2,77.7,128.7,77.8,130.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.9093,
    y1: 118.3278,
    x2: 110.9093,
    y2: 91.2086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M112.2,113.3L112.2,113.3c-0.1,0.6-0.2,1.2-0.3,1.8c-0.1,0.7-0.4,1.3-0.9,1.8c-0.5,0.6-0.8,0.9-1.5,1.2 c0-0.3,0.1-0.7,0.1-1c0.2-1.6,0.4-3.2,0.7-4.8c0-0.1,0-0.1,0-0.2L112.2,113.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.9511,
    y1: 118.3281,
    x2: 102.9511,
    y2: 91.2067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M105,109.1l-1.2,10.6c-0.1,0.8-0.5,1.5-1,2.1c-0.6,0.8-1.1,0.9-1.9,1.4h0c0-0.3,0.1-0.6,0.1-0.7 c0.3-2.9,0.7-5.8,1-8.8c0.2-2,0.4-4,0.7-5.9L105,109.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.7985,
    y1: 118.3282,
    x2: 94.7985,
    y2: 91.2071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M93.1,127.7l-0.4,0.2h0c0-0.1,0-0.1,0-0.2c0.1-1.5,0.2-3,0.3-4.5c0.2-2.9,0.4-5.7,0.6-8.6 c0.2-2.9,0.4-5.7,0.6-8.6c0.1-1,0.1-2,0.2-3l2.4,1.4c-0.2,3-0.5,5.9-0.7,8.9c-0.2,2.5-0.4,5-0.6,7.6c-0.1,1.3-0.2,2.5-0.3,3.8 C95.1,125.8,94.1,127.1,93.1,127.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.3966,
    y1: 95.728,
    x2: 46.3966,
    y2: 39.9602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#838383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M45.3,86.3c0.6,0.3,1.2,0.7,1.7,1.2c0.2,0.2,0.4,0.5,0.6,0.7l-1.8,1L45.3,86.3L45.3,86.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.9517,
    y1: 95.7278,
    x2: 37.9517,
    y2: 39.9604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#838383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M38.2,93.6c-0.8-4.2-1.6-8.5-2.4-12.7v0c0.2,0.1,0.5,0.3,0.7,0.4c0.1,1.4,0.3,2.8,0.4,4.2 c0,0.4,0.1,1.1,0.2,1.6c0.1,0.2,0.1,0.3,0.2,0.5c0.5,0.7,1.2,0.6,1.9,0.2c0,0.1,0,0.2,0.1,0.3c0.3,1.5,0.5,3,0.8,4.4L38.2,93.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.3495,
    y1: 95.7279,
    x2: 31.3495,
    y2: 39.9605
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#838383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M31.8,92c0.3,1.6,0.6,3.1,0.9,4.7l-1.7,1h0c-0.3-1.6-0.7-3.3-1-4.9c0.6,0.1,1.2-0.4,1.6-0.6 C31.6,92.1,31.7,92.1,31.8,92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.2457,
    y1: 95.7281,
    x2: 21.2457,
    y2: 39.9606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#838383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M17.5,70.2c0.7,0.4,1.3,1.2,1.7,1.8c0.4,0.7,0.5,1.4,0.6,2.2c0.3,1.4,0.6,2.8,0.9,4.2c0.7,3,1.3,5.9,2,8.9 c0.7,3,1.3,6,2,8.9c0.3,1.5,0.7,3,1,4.5l-0.1,0.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.3-0.2-0.5-0.5-0.7-0.8c-0.4-0.6-0.7-1.2-0.9-1.8 c-0.3-1.3-0.6-2.7-0.9-4c-0.6-2.7-1.3-5.3-1.9-8c-1.3-5.3-2.5-10.7-3.8-16C17,70,17.2,70.1,17.5,70.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.7363,
    y1: 92.777,
    x2: 30.7363,
    y2: 89.3037
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M31.7,91.5c0,0.2,0.1,0.4,0.1,0.5c-0.1,0-0.1,0.1-0.2,0.1c-0.4,0.3-1,0.7-1.6,0.6c-0.1-0.5-0.2-0.9-0.3-1.4 l0.1,0c0.7-0.4,1.3-1.3,1.5-2C31.4,90,31.5,90.8,31.7,91.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.2094,
    y1: 88.0455,
    x2: 38.2094,
    y2: 85.9259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M39,86.1c0.1,0.6,0.2,1.1,0.3,1.7c-0.7,0.4-1.4,0.5-1.9-0.2c-0.1-0.1-0.2-0.3-0.2-0.5 c0.3-0.2,0.6-0.3,0.9-0.5c0.3-0.2,0.6-0.4,0.9-0.6h0C39,86,39,86,39,86.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.6946,
    y1: 63.7443,
    x2: 28.6946,
    y2: 56.8356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M29.6,60.5c0.1,1.1,0.3,2.2,0.4,3.3l-1.9-1.1v0c-0.1-0.9-0.2-1.9-0.4-2.8c0-0.3-0.3-2.6-0.4-2.8 c0,0,0,0,0.1,0c0.5-0.2,1.1-0.2,1.5,0.3c0.4,0.5,0.4,1,0.4,1.6C29.4,59.4,29.5,59.9,29.6,60.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.6041,
    y1: 69.7498,
    x2: 38.6041,
    y2: 51.4016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M40.4,69.7l-1.9-1.1c-0.3-2.9-0.6-5.7-0.8-8.6c-0.1-1.4-0.3-2.9-0.4-4.3c-0.1-0.7-0.1-1.4-0.2-2.1 c0-0.3-0.2-1.8-0.3-2.1c0.5-0.2,1.1-0.3,1.5,0.2c0.2,0.3,0.3,0.6,0.4,0.9c0.1,0.4,0.1,0.8,0.1,1.2c0.1,0.8,0.2,1.6,0.2,2.3 c0.2,1.5,0.3,3,0.4,4.5C39.8,63.7,40.1,66.7,40.4,69.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.9787,
    y1: 75.153,
    x2: 47.9787,
    y2: 45.9756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M48.9,60.6c0.3,4.8,0.6,9.7,0.9,14.5l-1.8-1.1c-0.3-4.7-0.6-9.3-0.8-14c-0.1-2.3-0.3-4.7-0.4-7 c-0.1-1.2-0.1-2.3-0.2-3.5c0-0.6-0.1-1.1-0.1-1.7c0-0.4-0.1-1.4-0.2-1.8c0,0,0,0,0,0c0.4-0.2,1-0.2,1.4,0.1c0.4,0.4,0.5,1,0.5,1.5 c0,0.6,0.1,1.3,0.1,1.9c0.1,1.3,0.2,2.5,0.2,3.8C48.6,55.8,48.8,58.2,48.9,60.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.1197,
    y1: 78.7446,
    x2: 110.1197,
    y2: 68.7441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M111.9,68.9c-0.1,0.3-0.4,1.9-0.4,2.2c-0.1,0.7-0.3,1.5-0.4,2.2c-0.3,1.5-0.5,2.9-0.8,4.4l-1.9,1.1 c0.3-1.6,0.6-3.2,0.9-4.7c0.1-0.8,0.3-1.6,0.4-2.4c0.1-0.4,0.1-0.8,0.2-1.2c0.1-0.4,0.1-0.8,0.4-1.1c0.2-0.4,0.5-0.5,0.9-0.6 C111.4,68.7,111.7,68.8,111.9,68.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.8173,
    y1: 85.1451,
    x2: 99.8173,
    y2: 63.2453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M102.3,63.4c-0.2,0.4-0.2,0.9-0.3,1.3c-0.1,0.4-0.1,0.8-0.2,1.3c-0.1,0.9-0.3,1.7-0.4,2.6 c-0.3,1.7-0.5,3.5-0.8,5.2c-0.5,3.5-1.1,6.9-1.6,10.3l-1.9,1.1c0.5-3.6,1.1-7.2,1.6-10.8c0.3-1.8,0.5-3.6,0.8-5.4 c0.1-0.9,0.3-1.8,0.4-2.8c0.1-0.5,0.1-0.9,0.2-1.4c0.1-0.4,0.1-0.8,0.4-1.2c0.3-0.3,0.6-0.5,1-0.4C102,63.3,102.2,63.3,102.3,63.4 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.8958,
    y1: 91.1142,
    x2: 89.8958,
    y2: 57.762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M88.8,90.1l-1.8,1c0-0.1,0-0.2,0-0.3c0.7-5.5,1.4-10.9,2-16.4c0.3-2.7,0.7-5.5,1-8.2 c0.2-1.4,0.3-2.8,0.5-4.2c0.1-0.7,0.2-1.4,0.3-2.1c0.1-0.6,0.1-1.3,0.6-1.8c0.4-0.4,1-0.4,1.4-0.2c-0.1,0.4-0.3,1.7-0.3,2 c-0.1,0.7-0.2,1.3-0.2,2c-0.2,1.3-0.3,2.7-0.5,4c-0.3,2.7-0.7,5.4-1,8C90.1,79.3,89.4,84.7,88.8,90.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.0292,
    y1: 89.9603,
    x2: 81.0292,
    y2: 52.296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M82.7,89c0.1,0,0.1,0.1,0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c-0.4,0.7-1.2,0.7-1.8,0.4c-0.9-0.5-1.3-0.7-1.8-1.6 c-0.5-0.9-0.5-1.5-0.4-2.5c0.1-1.7,0.3-3.3,0.4-5c0.3-3.3,0.6-6.7,0.8-10c0.3-3.3,0.6-6.7,0.8-10c0.2-1.8,0.3-3.6,0.5-5.4 c0-0.4,0.1-0.9,0.1-1.3c0-0.4,0.1-0.8,0.4-1.1c0.4-0.6,1-0.6,1.6-0.3c-0.2,0.4-0.2,0.8-0.2,1.2c0,0.4-0.1,0.8-0.1,1.2 c-0.1,0.8-0.1,1.5-0.2,2.3c-0.1,1.6-0.3,3.1-0.4,4.7c-0.3,3.1-0.5,6.2-0.8,9.4c-0.3,3.1-0.5,6.2-0.8,9.4c-0.1,1.6-0.3,3.1-0.4,4.7 c-0.1,0.9,0.1,1.6,0.5,2.3C81.5,88.4,81.9,88.6,82.7,89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.074,
    y1: 84.9298,
    x2: 72.074,
    y2: 46.7921
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M74,84c0.1,0,0.1,0.1,0.2,0.1c0,0.1-0.1,0.2-0.1,0.2c-0.4,0.7-1.2,0.8-1.9,0.4c-0.9-0.5-1.3-0.7-1.8-1.6 c-0.5-0.9-0.5-1.5-0.4-2.6c0.1-1.7,0.2-3.4,0.3-5c0.2-3.4,0.4-6.8,0.6-10.1c0.2-3.4,0.4-6.8,0.6-10.1c0.1-1.8,0.2-3.6,0.3-5.4 c0-0.5,0.1-0.9,0.1-1.4c0-0.4,0.1-0.8,0.3-1.1c0.4-0.6,1-0.6,1.6-0.4c-0.2,0.4-0.2,0.8-0.2,1.2c0,0.4,0,0.8-0.1,1.2 c0,0.8-0.1,1.6-0.1,2.3c-0.1,1.6-0.2,3.2-0.3,4.7c-0.2,3.2-0.4,6.3-0.6,9.5c-0.2,3.2-0.4,6.3-0.6,9.5c-0.1,1.6-0.2,3.2-0.3,4.7 c-0.1,0.9,0.1,1.6,0.5,2.4C72.8,83.4,73.2,83.5,74,84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.3177,
    y1: 79.8871,
    x2: 63.3177,
    y2: 41.2522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M65.4,79c-0.1,0.4-0.4,0.7-0.8,0.8c-0.4,0.1-0.7,0.1-1.1-0.1c-0.2-0.1-0.9-0.5-1.1-0.7 c-0.7-0.5-1.1-1.4-1.3-2.3c-0.1-0.4,0-2.1,0-2.5c0.1-1.7,0.1-3.4,0.2-5.1c0.1-3.4,0.2-6.8,0.3-10.2c0.1-3.4,0.2-6.8,0.3-10.2 c0.1-1.9,0.1-3.7,0.2-5.6c0-0.7,0.2-1.6,1.1-1.8c0.3-0.1,0.6,0,0.9,0.1v0c-0.2,0.4-0.2,0.8-0.2,1.2c0,0.4,0,0.8,0,1.2 c0,0.8-0.1,1.6-0.1,2.4c-0.1,1.6-0.1,3.2-0.2,4.8c-0.1,3.2-0.2,6.4-0.3,9.7c-0.1,3.2-0.2,6.4-0.3,9.7C63.1,72,63,73.6,63,75.2 c0,0.9,0.1,1.6,0.6,2.4c0.2,0.3,0.5,0.6,0.8,0.8C64.8,78.7,65.1,78.9,65.4,79z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M59.3,80.6c0.9-0.5,2,0,2.7,0.5c0.8,0.6,1.4,1.3,1.9,2.2L59.3,80.6L59.3,80.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M30.1,63.8c0.9-0.5,2,0,2.7,0.5c0.8,0.6,1.4,1.3,1.9,2.2L30.1,63.8L30.1,63.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M32.5,71c0.2,0.6,0.3,1.8-0.4,2.2l-1.2,0.7c0.1-0.1,0.2-0.2,0.4-0.3c0.7-0.7,0.6-1.9,0.5-2.8 c-0.2-1-0.6-1.8-1.1-2.6c-0.6-0.8-1.2-1.5-2-2c-0.6-0.3-1.4-0.6-2-0.3c0,0,0.1-0.1,0.1-0.1v0l0,0c0.4-0.3,1.1-0.3,1.5-0.2 c0.6,0.1,1,0.3,1.4,0.7c0.7,0.6,1.4,1.8,1.9,2.5C31.9,69.5,32.3,70.2,32.5,71z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M61.7,87.8c0.2,0.6,0.3,1.8-0.4,2.2h0l-1.2,0.7l0,0c0.5-0.3,0.8-1,0.8-1.7c0.1-0.9-0.2-2-0.5-2.8 c-0.4-0.9-0.9-1.7-1.6-2.4c-0.6-0.6-1.5-1.3-2.5-1.2c-0.2,0-0.4,0-0.6,0.1c0,0-0.1,0-0.1,0l0.3-0.2v0c0.4-0.2,1.1-0.3,1.5-0.2 c0.5,0.1,1,0.3,1.4,0.7c0.7,0.6,1.4,1.8,1.9,2.5C61.1,86.3,61.5,87,61.7,87.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.1098,
    y1: 95.7271,
    x2: 83.1098,
    y2: 39.9607
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#838383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M84.7,36.1l-3.2-1.9C82.8,34.2,84,35.3,84.7,36.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.3015,
    y1: 95.7267,
    x2: 112.3015,
    y2: 39.9611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#838383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M113.9,53l-3.2-1.9C112,51,113.2,52.1,113.9,53z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M112.7,58.5c-0.1,1-0.5,2.1-1.4,2.6l-0.4,0.3l0,0c0.5-0.3,0.8-1,0.8-1.7c0.1-0.9-0.2-2-0.5-2.8 c-0.4-0.9-0.9-1.7-1.6-2.4c-0.6-0.6-1.5-1.3-2.5-1.2c-0.3,0-0.5,0.1-0.7,0.2l1.3-0.8c1-0.6,2.1-0.2,2.9,0.4 c0.8,0.6,1.4,1.5,1.8,2.4C112.7,56.5,112.8,57.5,112.7,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.3207,
    y1: 95.7277,
    x2: 80.3207,
    y2: 39.9605
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#838383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M83.5,41.6c-0.1,1-0.5,2.1-1.4,2.7l-0.5,0.3c0.1-0.1,0.3-0.2,0.4-0.3c0.7-0.7,0.6-1.9,0.5-2.7 c-0.2-1-0.6-1.8-1.1-2.6c-0.6-0.8-1.2-1.5-2-2c-0.6-0.4-1.5-0.6-2.2-0.3l1.3-0.8c0.9-0.5,2-0.2,2.8,0.4c0.8,0.6,1.4,1.5,1.8,2.4 C83.4,39.6,83.6,40.6,83.5,41.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M106.3,53.5c0.2-0.1,0.4-0.2,0.7-0.2c1,0,1.9,0.6,2.5,1.2c0.7,0.7,1.2,1.5,1.6,2.4c0.4,0.8,0.6,1.9,0.5,2.8 c-0.1,0.7-0.3,1.3-0.8,1.7c-0.2,0.2-0.5,0.3-0.9,0.3c-1,0-1.9-0.6-2.5-1.2c-0.7-0.7-1.2-1.5-1.6-2.4c-0.4-0.8-0.6-1.9-0.5-2.8 C105.3,54.5,105.6,53.8,106.3,53.5z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M82.4,41.6c0.2,0.9,0.2,2-0.5,2.7c-0.1,0.1-0.2,0.2-0.4,0.3c-0.7,0.4-1.6,0.2-2.3-0.2c-0.9-0.5-1.5-1.2-2-2 c-0.5-0.8-0.9-1.7-1.1-2.6c-0.2-0.9-0.2-2,0.5-2.8c0.1-0.2,0.3-0.3,0.5-0.4c0.7-0.3,1.5-0.1,2.2,0.3c0.9,0.5,1.5,1.2,2,2 C81.8,39.7,82.2,40.6,82.4,41.6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M26.5,65.9c0.7-0.3,1.4,0,2,0.3c0.9,0.5,1.5,1.2,2,2c0.5,0.8,0.9,1.7,1.1,2.6c0.2,0.9,0.2,2-0.5,2.8 c-0.1,0.1-0.2,0.2-0.4,0.3c0,0,0,0,0,0c-0.7,0.4-1.6,0.2-2.3-0.2c-0.9-0.5-1.5-1.2-2-2C26,70.9,25.6,70,25.4,69 c-0.2-0.9-0.2-2,0.5-2.8C26.1,66.1,26.3,65.9,26.5,65.9z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M55.7,82.7c0.2-0.1,0.4-0.1,0.6-0.1c1,0,1.9,0.6,2.5,1.2c0.7,0.7,1.2,1.5,1.6,2.4c0.4,0.8,0.6,1.9,0.5,2.8 c-0.1,0.7-0.3,1.3-0.8,1.7c-0.2,0.2-0.5,0.3-0.9,0.3c-1,0-1.9-0.6-2.5-1.2c-0.7-0.7-1.2-1.5-1.6-2.4c-0.4-0.8-0.6-1.9-0.5-2.8 c0.1-0.8,0.4-1.5,1-1.8C55.6,82.7,55.6,82.7,55.7,82.7z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M134.3,71.9l2.5,1.4v1.9l-5.2,3l-49.4,27.6v-0.9v-1.7v-5.1v-4.2l4.8-2.8l1.8-1l3.7-2.1l4.8-2.8l1.9-1.1 l3.6-2.1v0l4.7-2.7l1-0.6l1.9-1.1l4-2.3l18.4-10.6L133,64l2.3,1.3c0,0,0,0,0,0c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.2,0.3 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.3,0,0.4c0,0.2-0.1,0.3-0.1,0.5L134.3,71.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M55.8,82.6L55.8,82.6l-0.3,0.2c-0.7,0.3-1,1-1,1.8c-0.1,0.9,0.2,2,0.5,2.8c0.4,0.9,0.9,1.7,1.6,2.4 c0.6,0.6,1.5,1.3,2.5,1.2c0.4,0,0.7-0.1,0.9-0.3l0,0l1.2-0.7h0c0.7-0.4,0.6-1.6,0.4-2.2c-0.2-0.8-0.6-1.5-1-2.2 c-0.5-0.7-1.2-1.9-1.9-2.5c-0.4-0.4-0.8-0.6-1.4-0.7C56.9,82.4,56.3,82.4,55.8,82.6z M26.6,65.8L26.6,65.8c0,0-0.1,0.1-0.1,0.1 c-0.2,0.1-0.4,0.2-0.6,0.4c-0.7,0.7-0.6,1.9-0.5,2.8c0.2,1,0.6,1.8,1.1,2.6c0.6,0.8,1.2,1.5,2,2c0.7,0.4,1.6,0.6,2.3,0.2 c0,0,0,0,0,0l1.2-0.7c0.7-0.4,0.6-1.6,0.4-2.2c-0.2-0.8-0.6-1.5-1-2.2c-0.5-0.7-1.2-1.9-1.9-2.5c-0.4-0.4-0.8-0.6-1.4-0.7 C27.7,65.5,27.1,65.5,26.6,65.8L26.6,65.8z M82.2,105.8L9.1,64.5L5,62.1l-0.3-2l2.5-1.4l-1.6-4.9c-0.1-0.1-0.1-0.3-0.1-0.5 c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0,0,0,0,0,0l2.3-1.3l0.4,0.7l15.7,9.1 l3.6,2.1v0l1.9,1.1l0.1,0h0l4.7,2.7v0l0.4,0.2l3.5,2l1.9,1.1l4.6,2.7l2.9,1.7l1.8,1.1l9.5,5.5l4.7,2.7l0,0l18.3,10.5v4.2v5.1v1.7 V105.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.3315,
    y1: 139.9992,
    x2: 70.3315,
    y2: 64.5157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DBDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1801,
    style: {
      stopColor: "#CFCFCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7074,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3A3A3"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M32.7,96.7c-0.3-1.6-0.6-3.1-0.9-4.7c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.7-0.3-1.5-0.4-2.2 c-0.4-2.2-0.9-4.4-1.3-6.6c-0.3-1.4-0.5-2.8-0.8-4.1c-0.2-0.8-0.7-1.6-1.2-2.1c-0.4-0.4-0.8-0.7-1.2-0.9c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.5-0.3-1.3-0.6-1.6,0.1c-0.1,0.4-0.1,0.7,0,1c0.1,0.4,0.2,0.8,0.3,1.2c0.3,1.6,0.7,3.2,1,4.8 c0.6,2.9,1.2,5.9,1.9,8.8c0.6,2.9,1.2,5.9,1.9,8.8c0.3,1.4,0.6,2.8,0.9,4.1c0.1,0.4,0.2,0.7,0.3,1.1c0.2,0.4,0.4,0.7,0.7,1.1 c0.6,0.8,1,0.9,1.9,1.4c0.5,0.3,1.3,0.5,1.5-0.2c0.1-0.4,0-0.7-0.1-1.1c0-0.1,0-0.2-0.1-0.3c-0.1-0.3-0.1-0.6-0.2-0.9 c-0.3-1.6-0.6-3.2-1-4.8C33.2,99.1,32.9,97.9,32.7,96.7z M36.5,81.2c-0.2-0.1-0.5-0.3-0.7-0.4c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.5-0.3-1.3-0.6-1.6,0.1c-0.1,0.4-0.1,0.7,0,1c0.1,0.4,0.1,0.8,0.2,1.2c0.3,1.6,0.6,3.1,0.9,4.7c0.5,2.9,1.1,5.8,1.6,8.7 c0.5,2.9,1.1,5.8,1.6,8.7c0.2,1.3,0.5,2.7,0.8,4c0.2,0.8,0.5,1.5,1,2.1c0.6,0.8,1,0.9,1.8,1.4c0.5,0.3,1.3,0.5,1.5-0.2 c0.1-0.4,0-0.7,0-1c0-0.1,0-0.2-0.1-0.3c0-0.3-0.1-0.6-0.1-0.9c-0.3-1.6-0.5-3.1-0.8-4.7c-0.5-2.9-1-5.8-1.5-8.7 c-0.2-1.4-0.5-2.9-0.7-4.3c-0.3-1.5-0.5-3-0.8-4.4c0-0.1,0-0.2-0.1-0.3c-0.1-0.6-0.2-1.1-0.3-1.7c0,0,0-0.1,0-0.1 c-0.1-0.6-0.2-1.3-0.3-1.9c-0.2-0.8-0.7-1.6-1.2-2.1C37.1,81.7,36.8,81.4,36.5,81.2z M108.6,92.7c-0.3-0.6-1-0.4-1.5-0.2 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.4,0.2-0.7,0.4-1.1,0.7c-0.2,0.2-0.4,0.3-0.6,0.5c-0.6,0.6-1.1,1.5-1.2,2.3c-0.4,3.9-0.9,7.7-1.3,11.6 c-0.2,2-0.4,4-0.7,5.9c-0.3,2.9-0.7,5.8-1,8.8c0,0.2-0.1,0.4-0.1,0.7c-0.1,0.5-0.1,1,0,1.3c0.3,0.6,1,0.4,1.5,0.2 c0.7-0.4,1.4-0.7,2-1.4c0.6-0.6,1.1-1.5,1.2-2.3c0.7-5.8,1.3-11.7,2-17.5c0.3-2.9,0.7-5.8,1-8.8C108.6,94.3,108.8,93.2,108.6,92.7z  M96.6,98.6c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.3-0.6,0.6-0.8,1c-0.5,0.8-0.6,1.2-0.7,2.1c0,0.3,0,0.6-0.1,0.9c-0.1,1-0.1,2-0.2,3 c-0.2,2.9-0.4,5.7-0.6,8.6c-0.2,2.9-0.4,5.7-0.6,8.6c-0.1,1.5-0.2,3-0.3,4.5c0,0.1,0,0.1,0,0.2c0,0.3-0.1,0.6,0,0.9 c0,0.3,0.1,0.5,0.4,0.7c0.6,0.4,1.5-0.3,1.9-0.5c0.7-0.4,1.3-1.1,1.6-1.8c0.4-0.8,0.4-1.2,0.5-2.1c0.1-1.3,0.2-2.6,0.3-4 c0.2-2.8,0.5-5.7,0.7-8.5c0.2-2.8,0.5-5.7,0.7-8.5c0.1-1.5,0.3-3,0.4-4.5c0-0.5,0.3-1.4-0.4-1.7c-0.3-0.2-0.6-0.1-0.9,0 c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.3,0.2-0.5,0.3C96.8,98.5,96.7,98.5,96.6,98.6z M17.5,70.2c-0.2-0.1-0.5-0.3-0.7-0.4 c-0.1-0.1-0.3-0.2-0.4-0.2c-0.3-0.2-0.6-0.3-1-0.3c-0.7,0.1-0.6,1-0.5,1.5c0.4,1.6,0.8,3.2,1.1,4.9c0.7,3,1.4,5.9,2.1,8.9 c0.7,3,1.4,5.9,2.1,8.9c0.3,1.4,0.7,2.8,1,4.2c0.1,0.4,0.4,1.8,0.6,2.1c0.3,0.8,0.9,1.5,1.6,2c0.3,0.3,0.7,0.5,1.1,0.7 c0.3,0.2,0.6,0.3,1,0.2c0.7-0.2,0.5-1.1,0.4-1.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c-0.3-1.5-0.7-3-1-4.5c-0.7-3-1.3-5.9-2-8.9 c-0.7-3-1.3-5.9-2-8.9c-0.3-1.4-0.6-2.8-0.9-4.2c-0.2-0.7-0.3-1.5-0.6-2.2C18.8,71.4,18.2,70.6,17.5,70.2z M118,87.3 c-0.3-0.7-1.1-0.4-1.6-0.1c-0.1,0-0.2,0.1-0.2,0.1c-0.6,0.3-1.2,0.6-1.6,1.1c-0.5,0.6-1,1.4-1.2,2.2c-0.1,0.7-0.2,1.4-0.3,2.1 c-0.1,0.7-0.2,1.4-0.3,2.1c-0.4,2.9-0.8,5.9-1.2,8.8c-0.4,2.9-0.8,5.8-1.2,8.7c0,0.1,0,0.1,0,0.2c-0.2,1.6-0.4,3.2-0.7,4.8 c0,0.3-0.1,0.7-0.1,1c0,0.1,0,0.1,0,0.2c0,0.4-0.1,0.7,0,1.1c0.3,0.7,1,0.5,1.5,0.2c0.8-0.5,1.2-0.7,1.8-1.4 c0.5-0.7,0.8-1.3,0.9-2.2c0.2-1.4,0.4-2.8,0.6-4.2c0.4-2.9,0.9-5.9,1.3-8.8c0.4-2.9,0.9-5.9,1.3-8.8c0.2-1.6,0.5-3.2,0.7-4.8 c0.1-0.4,0.1-0.8,0.2-1.2C118.1,88,118.2,87.6,118,87.3z M82.2,105.8l49.4-27.6l-9.2,39.1c0,0,0,0,0,0.1c-0.1,0.5-0.6,0.9-1,1.2 c-12,6.9-24,13.9-36,20.8c-1.6,0.9-3.6,0.9-5.1,0c-20.2-11.7-40.4-23.3-60.6-35c-0.4-0.2-0.9-0.6-1-1.2c0,0,0,0,0-0.1L9.1,64.5 L82.2,105.8z M77.8,132.2c0-0.1,0-0.7,0-1.2c0-0.4,0-0.8,0-0.9c-0.1-1.4-0.1-2.9-0.2-4.3c-0.1-2.7-0.2-5.5-0.4-8.2 c-0.1-2.7-0.2-5.5-0.4-8.2c0-0.6-0.1-1.2-0.1-1.8c0-0.6,0-1.2-0.2-1.8c-0.3-0.8-0.7-1.4-1.3-2c-0.5-0.4-1-0.7-1.5-1 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.5-0.3-1.3-0.5-1.5,0.2c-0.1,0.3,0,1.8,0,2.1c0.1,1.4,0.2,2.9,0.3,4.3c0.2,2.7,0.3,5.5,0.5,8.2 c0.2,2.7,0.3,5.5,0.5,8.2c0,0.6,0.1,1.2,0.1,1.8c0,0.2,0.1,1.6,0.1,1.8c0.1,0.7,0.6,1.5,1.1,2c0.5,0.6,1.1,1,1.8,1.3 C76.9,132.8,77.7,133,77.8,132.2z M69.1,126.9c0-0.3,0-0.7-0.1-1c0,0,0,0,0-0.1c-0.1-1.4-0.2-2.9-0.3-4.4c-0.2-2.8-0.4-5.5-0.6-8.3 c-0.2-2.8-0.4-5.5-0.6-8.3c-0.1-1.2-0.2-2.5-0.3-3.7c-0.1-0.8-0.2-1.3-0.7-2c-0.2-0.4-0.5-0.7-0.8-1c-0.3-0.3-0.6-0.4-0.9-0.6 c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.5-0.2-0.9-0.1c-0.6,0.3-0.4,1.2-0.3,1.7c0.1,1.5,0.3,2.9,0.4,4.4 c0.2,2.8,0.5,5.5,0.7,8.3c0.2,2.8,0.5,5.5,0.7,8.3c0.1,1.3,0.2,2.5,0.3,3.8c0.1,0.9,0.1,1.2,0.5,2c0.4,0.7,1,1.4,1.7,1.8 c0.4,0.2,0.7,0.4,1.1,0.6c0.3,0.1,0.6,0.1,0.8,0C69,127.5,69.1,127.2,69.1,126.9z M60.4,121.9c0-0.3,0-0.7-0.1-1c0,0,0-0.1,0-0.1 c-0.2-1.5-0.3-3-0.5-4.4c-0.3-2.8-0.6-5.6-0.9-8.4c-0.3-2.8-0.6-5.6-0.9-8.4c-0.1-1.3-0.3-2.6-0.4-3.8c-0.1-0.9-0.2-1.3-0.7-2.1 c-0.5-0.8-1-1.1-1.8-1.6c-0.1-0.1-0.3-0.2-0.4-0.3v0c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.5-0.2-0.9,0c-0.6,0.3-0.4,1.3-0.3,1.7 c0.2,1.5,0.3,3,0.5,4.5c0.3,2.8,0.7,5.6,1,8.4c0.3,2.8,0.7,5.6,1,8.4c0.2,1.3,0.3,2.6,0.5,3.9c0.1,0.9,0.1,1.2,0.5,2 c0.4,0.7,1,1.4,1.7,1.8c0.4,0.2,0.7,0.4,1.1,0.6c0.3,0.1,0.6,0.1,0.8,0C60.3,122.4,60.4,122.1,60.4,121.9z M52,117.5 c0.2-0.3,0.1-1,0-1.5c0-0.2-0.1-0.4-0.1-0.5c-0.4-2.9-0.8-5.7-1.3-8.6c-0.8-5.7-1.7-11.5-2.5-17.2c-0.1-0.5-0.3-1.1-0.6-1.5 c-0.2-0.3-0.4-0.5-0.6-0.7c-0.5-0.5-1.1-0.8-1.7-1.2c-0.1-0.1-0.2-0.1-0.4-0.2c-0.4-0.2-1.2-0.5-1.5,0.1c-0.2,0.5,0,1.5,0.1,2 c0.4,2.9,0.8,5.7,1.3,8.6c0.8,5.7,1.7,11.5,2.5,17.2c0.1,0.8,0.7,1.7,1.2,2.3c0.6,0.6,1.3,1,2,1.4C51,117.9,51.7,118.1,52,117.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.7446,
    y1: 95.7281,
    x2: 70.7446,
    y2: 39.9606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7942,
    style: {
      stopColor: "#838383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878787"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M65.4,79c0.1-0.4,0.2-0.8,0.2-1.1c0.1-1.9,0.2-3.7,0.3-5.6c0.2-3.4,0.3-6.8,0.5-10.2 c0.2-3.4,0.3-6.8,0.5-10.2c0.1-1.7,0.2-3.4,0.2-5.1c0-0.4,0-0.8,0.1-1.3c0-0.4,0-0.9-0.1-1.3c-0.2-0.8-0.7-1.7-1.5-2.1 c-0.4-0.2-0.7-0.4-1.1-0.6c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.1-0.5-0.2-0.9-0.1c-0.9,0.2-1.1,1.1-1.1,1.8c-0.1,1.9-0.1,3.7-0.2,5.6 c-0.1,3.4-0.2,6.8-0.3,10.2c-0.1,3.4-0.2,6.8-0.3,10.2c-0.1,1.7-0.1,3.4-0.2,5.1c0,0.4-0.1,2.1,0,2.5c0.1,0.8,0.6,1.7,1.3,2.3 c0.1,0.1,0.9,0.6,1.1,0.7c0.4,0.2,0.7,0.3,1.1,0.1C65.1,79.7,65.3,79.4,65.4,79z M73.8,46.9c-0.6-0.2-1.2-0.2-1.6,0.4 c-0.2,0.4-0.3,0.7-0.3,1.1c0,0.5-0.1,0.9-0.1,1.4c-0.1,1.8-0.2,3.6-0.3,5.4c-0.2,3.4-0.4,6.8-0.6,10.1c-0.2,3.4-0.4,6.7-0.6,10.1 c-0.1,1.7-0.2,3.4-0.3,5c-0.1,1-0.1,1.6,0.4,2.6c0.5,0.9,0.9,1.1,1.8,1.6c0.7,0.4,1.4,0.3,1.9-0.4c0-0.1,0.1-0.2,0.1-0.2 c0.1-0.3,0.2-0.6,0.2-0.9c0-0.4,0.1-0.9,0.1-1.4c0.1-1.8,0.3-3.6,0.4-5.4c0.2-3.4,0.5-6.7,0.7-10.1c0.2-3.4,0.5-6.7,0.7-10.1 c0.1-1.7,0.2-3.4,0.4-5c0.1-1-0.1-1.7-0.6-2.5c-0.2-0.4-0.5-0.6-0.9-0.9c-0.3-0.2-0.7-0.4-1-0.6C74,47,73.9,47,73.8,46.9z  M111.9,68.9c-0.2-0.1-0.4-0.2-0.7-0.1c-0.4,0-0.7,0.2-0.9,0.6c-0.2,0.3-0.3,0.7-0.4,1.1c-0.1,0.4-0.1,0.8-0.2,1.2 c-0.1,0.8-0.3,1.6-0.4,2.4c-0.3,1.6-0.6,3.2-0.9,4.7l-1,0.6l-4.7,2.7c0.6-3.6,1.2-7.2,1.8-10.7c0.1-0.9,0.3-1.8,0.4-2.6 c0.2-1,0.4-1.7,0-2.7c-0.2-0.5-0.4-1-0.8-1.4c-0.3-0.3-0.8-0.5-1.2-0.8c-0.2-0.1-0.4-0.3-0.6-0.3c-0.2-0.1-0.4-0.1-0.6-0.1 c-0.4,0-0.7,0.1-1,0.4c-0.3,0.4-0.4,0.7-0.4,1.2c-0.1,0.5-0.1,0.9-0.2,1.4c-0.1,0.9-0.3,1.8-0.4,2.8c-0.3,1.8-0.5,3.6-0.8,5.4 c-0.5,3.6-1.1,7.2-1.6,10.8l-4.8,2.8c0.7-5.5,1.4-10.9,2-16.4c0.3-2.7,0.7-5.5,1-8.2c0.1-0.5,0.2-1.6,0.2-2.2 c-0.1-0.8-0.5-1.5-1-2.1c-0.2-0.3-0.5-0.4-0.8-0.6c-0.3-0.2-0.6-0.3-0.9-0.5c0,0-0.1,0-0.1-0.1c-0.5-0.2-1-0.2-1.4,0.2 c-0.5,0.5-0.5,1.2-0.6,1.8c-0.1,0.7-0.2,1.4-0.3,2.1c-0.2,1.4-0.3,2.8-0.5,4.2c-0.3,2.7-0.7,5.5-1,8.2c-0.7,5.5-1.4,10.9-2,16.4 c0,0.1,0,0.2,0,0.3l-4.8,2.8L63.9,83.3l0,0c-0.5-0.9-1.1-1.6-1.9-2.2c-0.7-0.5-1.8-1-2.7-0.5l0,0l-9.5-5.5 c-0.3-4.8-0.6-9.7-0.9-14.5c-0.1-2.4-0.3-4.8-0.4-7.3c-0.1-1.3-0.1-2.5-0.2-3.8c0-0.6-0.1-1.3-0.1-1.9c0-0.5-0.1-1.1-0.5-1.5 c-0.4-0.4-0.9-0.3-1.4-0.1c0,0,0,0,0,0c-0.3,0.1-1.3,0.8-1.5,0.9c-0.6,0.5-0.9,1-1.1,1.7c-0.3,0.8-0.2,1.2-0.1,2 c0.2,2.4,0.3,4.8,0.5,7.3c0.3,4.8,0.7,9.7,1.1,14.5l-4.6-2.7c-0.3-3-0.6-6-0.9-9c-0.1-1.5-0.3-3-0.4-4.5c-0.1-0.8-0.2-1.6-0.2-2.3 c0-0.4-0.1-0.8-0.1-1.2c0-0.3-0.1-0.6-0.4-0.9c-0.4-0.5-1-0.5-1.5-0.2c-0.1,0-0.2,0.1-0.3,0.2c-0.8,0.5-1.4,0.7-1.9,1.5 c-0.4,0.6-0.7,1.5-0.6,2.2c0.1,0.7,0.1,1.4,0.2,2.2c0.3,3,0.6,6,0.9,9l-0.4-0.2v0c-0.5-0.9-1.1-1.6-1.9-2.2c-0.7-0.5-1.8-1-2.7-0.5 l0,0h0l-0.1,0c-0.1-1.1-0.3-2.2-0.4-3.3c-0.1-0.5-0.1-1.1-0.2-1.6c-0.1-0.5,0-1.1-0.4-1.6c-0.4-0.5-1-0.5-1.5-0.3c0,0,0,0-0.1,0 c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.1-0.5,0.3-0.7,0.4c-0.9,0.6-1.4,1.8-1.5,2.8L8.9,51.6l-0.4-0.7l50.9-29.4l22.2,12.8l3.2,1.9l0,0 l26,15l3.2,1.9L133,64l-0.4,0.8l-18.4,10.6c0.2-0.8,0.3-1.6,0.5-2.4c0.1-0.8-0.1-1.6-0.5-2.3c-0.5-0.9-1-1.1-1.8-1.5 C112.2,69.1,112,69,111.9,68.9z M83.4,52.5c-0.6-0.2-1.2-0.2-1.6,0.3c-0.3,0.3-0.3,0.7-0.4,1.1c0,0.4-0.1,0.9-0.1,1.3 c-0.2,1.8-0.3,3.6-0.5,5.4c-0.3,3.3-0.6,6.7-0.8,10c-0.3,3.3-0.6,6.7-0.8,10c-0.1,1.7-0.3,3.3-0.4,5c-0.1,1-0.1,1.6,0.4,2.5 c0.5,0.9,0.9,1.1,1.8,1.6c0.7,0.4,1.4,0.3,1.8-0.4c0.1-0.1,0.1-0.2,0.1-0.3h0c0.1-0.3,0.1-0.6,0.2-0.9c0-0.4,0.1-0.9,0.1-1.3 c0.2-1.8,0.3-3.6,0.5-5.4c0.3-3.3,0.7-6.7,1-10c0.3-3.3,0.7-6.7,1-10c0.2-1.7,0.3-3.3,0.5-5c0.1-1-0.1-1.7-0.6-2.5 c-0.2-0.4-0.5-0.6-0.9-0.9c-0.3-0.2-0.7-0.4-1-0.6C83.6,52.5,83.5,52.5,83.4,52.5z M112.7,58.5c0.1-1.1-0.1-2-0.5-3 c-0.4-0.9-1-1.8-1.8-2.4c-0.8-0.6-1.9-0.9-2.9-0.4l-1.3,0.8c-0.6,0.3-0.9,1-1,1.8c-0.1,0.9,0.2,2,0.5,2.8c0.4,0.9,0.9,1.7,1.6,2.4 c0.6,0.6,1.5,1.3,2.5,1.2c0.4,0,0.7-0.1,0.9-0.3l0,0l0.4-0.3C112.2,60.6,112.6,59.5,112.7,58.5z M83.5,41.6c0.1-1.1-0.1-2-0.5-3 c-0.4-0.9-1-1.8-1.8-2.4c-0.8-0.6-1.9-0.9-2.8-0.4l-1.3,0.8c-0.2,0.1-0.3,0.2-0.5,0.4c-0.7,0.7-0.6,1.9-0.5,2.8 c0.2,1,0.6,1.8,1.1,2.6c0.6,0.8,1.2,1.5,2,2c0.7,0.4,1.6,0.6,2.3,0.2l0.5-0.3C83,43.7,83.4,42.6,83.5,41.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M92.4,87.9c1.6-0.9,3.2-1.9,4.8-2.8c0.2-1,0.3-2.1,0.5-3.1c-1.4-1.4-2.7-2.8-4.1-4.2 C93.3,81.2,92.9,84.6,92.4,87.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "48.5,54 49.8,75.2 58.2,80 59.2,41.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M45,72.4c-0.3-4.4-0.6-8.9-1-13.3c-1.4,1.6-2.8,3.2-4.2,4.9c0.2,1.9,0.4,3.8,0.6,5.8 C41.9,70.6,43.5,71.5,45,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M58.2,80c8,4.6,16,9.2,24,13.8c1.6-0.9,3.2-1.8,4.7-2.7c0.8-6,1.5-12,2.3-18.1c-1.4-1.5-2.8-2.9-4.2-4.4 c-0.6,6.6-1.3,13.2-1.9,19.7c-0.1,1.2-1,1.9-2.1,1.3c-0.2-0.1-0.5-0.3-0.7-0.4c-1-0.6-1.7-2.1-1.6-3.2c0.6-7.4,1.2-14.7,1.9-22.1 c-1.5-1.6-3-3.1-4.5-4.7c-0.6,8-1.1,16-1.7,24c-0.1,1.2-1,2-2.1,1.3c-0.2-0.1-0.5-0.3-0.7-0.4c-1-0.6-1.6-2-1.6-3.1 c0.5-8.8,1-17.7,1.6-26.5c-1.5-1.6-3.1-3.2-4.6-4.8c-0.4,9.5-0.9,18.9-1.3,28.4c-0.1,1.3-0.9,2.1-2.1,1.4 c-0.2-0.1-0.5-0.3-0.7-0.4c-1-0.6-1.6-2-1.6-3.1c0.3-10.4,0.7-20.8,1-31.2c-1-1.1-2-2.1-3-3.2C58.9,54.5,58.5,67.3,58.2,80z"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M111.8,102.2c-1.5,1.4-3,2.8-4.5,4.2c-0.3,2.9-0.7,5.8-1,8.7c-0.2,1.5-0.3,2.9-0.5,4.4c0,0.3-0.2,1.7-0.3,2 c-0.2,0.8-0.6,1.4-1.2,2c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.7,0.5-1.1,0.6c-0.7,0.2-1.2-0.1-1.2-0.8c0-0.2,0.2-2,0.2-2.2 c0.1-0.7,0.2-1.5,0.2-2.2c0.3-2.9,0.7-5.8,1-8.7c-1.5,1.3-2.9,2.7-4.4,4c-0.2,2.3-0.4,4.5-0.6,6.8c-0.1,1.1-0.2,2.3-0.3,3.4 c0,0.5-0.1,1-0.3,1.5c-0.2,0.6-0.6,1.1-1,1.6c-0.5,0.5-1,0.8-1.6,1.2c-0.4,0.2-1,0.4-1.3,0c-0.3-0.4-0.2-1.1-0.2-1.6 c0-0.6,0.1-1.2,0.1-1.8c0.2-2.3,0.3-4.5,0.5-6.8c-3.6,3.3-7.2,6.6-10.8,9.9c0.1,3.6,0.1,7.2,0.2,10.8c1,0,1.8-0.2,2.6-0.7 c12-6.9,24-13.9,36-20.8c0.4-0.2,0.9-0.6,1-1.2c0,0,0,0,0-0.1c2.5-10.6,5-21.1,7.5-31.7c-4.4,4.1-8.8,8.1-13.2,12.2 c-0.5,3.5-1.1,7-1.6,10.5c-0.3,1.7-0.5,3.5-0.8,5.2c-0.1,0.8-0.2,1.6-0.4,2.5c-0.1,0.4-0.1,0.9-0.3,1.3c-0.2,0.5-0.5,0.9-0.8,1.3 c-0.4,0.4-0.8,0.7-1.3,1c-0.4,0.2-0.7,0.5-1.2,0.4c-0.4,0-0.6-0.3-0.7-0.6c-0.1-0.2,0-0.4,0-0.6c0-0.2,0.1-0.5,0.1-0.7 c0.2-1.8,0.5-3.5,0.7-5.3C110.8,109.2,111.3,105.7,111.8,102.2z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M60.3,122.1c4.1,4.3,8.2,8.5,12.3,12.8c-17.7-10.2-35.4-20.4-53-30.6c-0.4-0.3-0.9-0.6-1-1.2c0,0,0,0,0-0.1 c-2.7-11-5.4-22.1-8.1-33.1c1.9,2,3.7,3.9,5.6,5.9c1,4.2,2,8.4,3,12.6c0.5,2.1,1,4.2,1.5,6.3c0.2,1,0.5,2,0.7,3 c0.1,0.5,0.2,1,0.4,1.5c0.1,0.6,0.4,1.1,0.7,1.6c0.4,0.6,0.9,1,1.5,1.3c0.4,0.2,0.9,0.6,1.5,0.6c0.5,0,0.6-0.4,0.7-0.8 c0-0.4-0.2-1.3-0.3-1.7c-0.5-2.1-0.9-4.2-1.4-6.3c-0.9-4.2-1.9-8.4-2.8-12.6c1.8,1.8,3.5,3.7,5.3,5.5c0.7,3.2,1.4,6.4,2,9.6 c0.3,1.6,0.7,3.2,1,4.8c0.2,0.8,0.3,1.5,0.5,2.3c0.2,1,0.3,1.5,1,2.4c0.3,0.4,0.7,0.8,1.1,1.1c0.2,0.1,1,0.6,1.2,0.7 c0.8,0.3,1.3-0.1,1.2-1c0-0.4-0.1-0.8-0.2-1.2c-0.1-0.4-0.2-0.8-0.2-1.2c-0.2-0.8-0.3-1.6-0.5-2.4c-0.6-3.2-1.3-6.4-1.9-9.6 c1.7,1.8,3.4,3.5,5.1,5.3c0.4,2.3,0.8,4.6,1.3,6.8c0.2,1.1,0.4,2.3,0.6,3.4c0.2,1.3,0.3,2.1,1.2,3.2c0.2,0.3,0.5,0.5,0.7,0.7 c0.2,0.2,0.5,0.4,0.8,0.5c0.4,0.2,0.9,0.6,1.4,0.5c0.6-0.1,0.6-0.7,0.5-1.2c-0.1-0.7-0.2-1.3-0.3-2c-0.4-2.3-0.8-4.6-1.2-6.9 c1.5,1.6,3,3.1,4.5,4.7c0.2,1.5,0.4,2.9,0.6,4.4c0.1,0.4,0.1,0.7,0.2,1.1c0.1,0.4,0.1,0.7,0.2,1.1c0.2,0.8,0.5,1.4,1.1,1.9 c0.6,0.7,1,0.9,1.8,1.3c0.4,0.2,0.7,0.5,1.2,0.5c0.3,0,0.6-0.2,0.7-0.5c0.1-0.4,0-0.7,0-1.1c-0.1-0.4-0.1-0.8-0.2-1.2 c-0.1-0.7-0.2-1.5-0.3-2.2c1.4,1.5,2.9,3,4.3,4.5c0.2,1.6,0.1,2.4,1.3,3.7c0.6,0.6,0.9,0.8,1.6,1.2c0.3,0.2,0.6,0.3,0.9,0.3 C60,122.7,60.2,122.5,60.3,122.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st47"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M19.7,57.8c-0.2-0.3,3.9-3,10.8-7.3c3.5-2.1,7.7-4.7,12.4-7.5l7.5-4.5l4-2.4l4.9-2.8l12.2,7 c28.2,16.3,50.7,30,50.3,30.7c-0.4,0.7-23.6-11.9-51.8-28.2l-5.8-3.4l-2.8-1.6L60,37l-0.7-0.4l0,0l-7.6,4.3l-7.6,4.3 c-4.8,2.7-9.1,5-12.7,7C24.3,55.9,19.9,58.1,19.7,57.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M71.4,40.4c8.5,4.9,18.1,10.5,24.9,14.6c4.3,2.6,9.1,5.4,12.4,7.5c7.1,4.3,12.1,7.6,12,7.9 c-0.2,0.3-5.6-2.5-12.9-6.4c-3.4-1.8-8.2-4.5-12.6-7c-6.9-3.8-16.6-9.4-25.1-14.3l-5.7-3.3l-5.1-3l-6.6,3.7l-6.4,3.6 c-4.4,2.5-9.3,5.2-12.6,7c-7.3,3.9-12.7,6.7-12.9,6.4c-0.2-0.3,4.9-3.6,12-7.9c3.3-2,8-4.9,12.4-7.4l6.3-3.8l7.8-4.6L71.4,40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M71.4,40.5c7.6,4.4,18.2,10.6,24.3,14.2c3.9,2.3,9.1,5.5,12.1,7.3c6.4,3.9,11.9,7.4,11.7,7.7 c-0.1,0.3-6-2.8-12.5-6.3c-3-1.6-8.4-4.6-12.3-6.8c-6.2-3.5-16.9-9.6-24.5-14l-10.8-6.3l-6.5,3.7l-6,3.4c-4,2.2-9.3,5.2-12.3,6.8 c-6.6,3.6-12.4,6.6-12.5,6.3c-0.1-0.3,5.4-3.8,11.7-7.7c2.9-1.8,8.2-4.9,12.1-7.3l5.9-3.5l7.6-4.5L71.4,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M71.3,40.5c6.8,3.9,18.4,10.7,23.8,13.9c3.5,2.1,9.2,5.5,11.8,7.1c5.7,3.5,11.6,7.2,11.5,7.5 c-0.1,0.2-6.4-3.1-12.2-6.2c-2.7-1.5-8.5-4.7-12-6.7C88.6,53,77,46.3,70.2,42.4l-10.9-6.3l-6.4,3.7l-5.6,3.1 c-3.5,2-9.3,5.2-12,6.7c-5.8,3.2-12.1,6.5-12.2,6.2c-0.1-0.2,5.9-4,11.5-7.5c2.6-1.6,8.3-5,11.8-7.1l5.5-3.2l7.4-4.3L71.3,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M71.3,40.6c5.9,3.4,18.5,10.7,23.2,13.6c3,1.8,9.3,5.5,11.5,6.9c4.9,3,11.4,7,11.3,7.2 c-0.1,0.2-6.8-3.4-11.9-6.1c-2.4-1.3-8.7-4.8-11.7-6.5c-4.8-2.7-17.4-9.9-23.4-13.3l-11-6.4L53,39.5l-5.1,2.9 c-3.1,1.7-9.4,5.3-11.7,6.6c-5.1,2.8-11.8,6.3-11.9,6.1c-0.1-0.2,6.3-4.2,11.3-7.2C37.8,46.5,44,42.8,47,41l5.1-3l7.2-4.2 L71.3,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M71.2,40.7c5.1,2.9,18.6,10.8,22.7,13.2c2.6,1.6,9.3,5.5,11.3,6.7c4.2,2.6,11.1,6.8,11,7 c-0.1,0.2-7.2-3.7-11.6-6.1c-2-1.1-8.8-4.9-11.4-6.4c-4.1-2.3-17.7-10.1-22.8-13l-11-6.4l-6.2,3.6L48.4,42 c-2.6,1.5-9.4,5.3-11.4,6.4c-4.4,2.4-11.5,6.2-11.6,6.1c-0.1-0.2,6.8-4.4,11-7c2-1.2,8.7-5.2,11.3-6.7l4.7-2.8l7-4.1L71.2,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M71.2,40.8c4.2,2.4,18.7,10.9,22.1,12.9c2.2,1.3,9.4,5.5,11,6.5c3.5,2.2,10.9,6.6,10.8,6.8 c-0.1,0.1-7.6-4-11.3-6c-1.7-0.9-8.9-5-11.1-6.3c-3.4-1.9-18-10.2-22.2-12.7l-11.1-6.5l-6.1,3.5l-4.3,2.4 c-2.2,1.2-9.5,5.4-11.1,6.3c-3.7,2-11.2,6.1-11.3,6c-0.1-0.1,7.3-4.6,10.8-6.8c1.6-1,8.8-5.2,11-6.5l4.3-2.5l6.8-4L71.2,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M71.1,40.9c3.4,2,18.8,10.9,21.5,12.5c1.7,1,9.4,5.5,10.7,6.3c2.8,1.7,10.6,6.4,10.6,6.6 c-0.1,0.1-8-4.3-11-5.9c-1.3-0.7-9.1-5.1-10.9-6.1C89.4,52.8,73.9,43.9,70.5,42l-11.2-6.5l-9.9,5.7c-1.8,1-9.5,5.4-10.9,6.1 c-2.9,1.6-10.9,6-11,5.9c-0.1-0.1,7.7-4.8,10.6-6.6c1.3-0.8,9-5.3,10.7-6.3l3.9-2.3l6.6-3.8L71.1,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M71.1,41c2.5,1.5,18.9,11,21,12.2c1.3,0.8,9.5,5.5,10.5,6.2c2.1,1.3,10.4,6.2,10.3,6.3 c0,0.1-8.4-4.6-10.6-5.8c-1-0.5-9.2-5.2-10.6-6c-2.1-1.2-18.5-10.6-21.1-12.1l-11.2-6.5l-9.4,5.4c-1.3,0.7-9.5,5.4-10.6,6 c-2.2,1.2-10.6,5.9-10.6,5.8c0-0.1,8.2-5,10.3-6.3c1-0.6,9.2-5.4,10.5-6.2l9.8-5.7L71.1,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M71,41.1l20.4,11.9l10.2,6c1.4,0.9,10.1,6,10.1,6.1c0,0.1-8.9-4.9-10.3-5.7l-10.3-5.8L70.6,41.7l-11.3-6.6 l-8.9,5.1l-10.3,5.8c-1.5,0.8-10.3,5.7-10.3,5.7c0-0.1,8.7-5.2,10.1-6.1l10.2-6l9.2-5.4L71,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M71,41.2l19.8,11.5l9.9,5.8c0.7,0.4,9.9,5.8,9.9,5.9c0,0-9.3-5.2-10-5.6l-10-5.7L70.7,41.6L59.3,35 l-8.4,4.8l-10,5.7c-0.7,0.4-10,5.6-10,5.6c0,0,9.1-5.4,9.9-5.9l9.9-5.8l8.6-5L71,41.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.1,50.5 41.7,44.8 51.3,39.2 59.3,34.6 70.9,41.3 90.2,52.4 99.8,58 109.4,63.7 99.7,58.2 90.1,52.6  70.8,41.5 59.3,34.9 51.4,39.4 41.7,45  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st47"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M58.2,80c-0.8,0-1.1-12.9-0.7-28.8c0.1-4,0.2-7.8,0.4-11.2c0.1-1.7,0.2-3.4,0.3-4.9c0.1-1.5,0.1-3,0.2-4.3 c0.3-5.2,0.6-8.4,1-8.4c0.4,0,0.8,3.2,1,8.4c0.1,1.3,0.1,2.7,0.2,4.3c0,1.5,0,3.2,0,4.9c0,3.4-0.1,7.2-0.2,11.2 C60,67.2,59,80.1,58.2,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M57.6,51.2c0.1-4.8,0.3-10.2,0.5-14.1l0.1-1.9c0-0.6,0-1.3,0.1-1.9c0-1.2,0.1-2.4,0.1-3.3 c0.2-4,0.5-7,0.9-7c0.3,0,0.6,3,0.9,7c0.1,0.9,0.1,2.1,0.2,3.3c0,0.6,0.1,1.2,0.1,1.9l0,1.9c0,3.9-0.1,9.3-0.2,14.1 c-0.1,4.8-0.3,10.2-0.5,14.1c-0.1,2.5-0.3,5.2-0.4,7c-0.3,4-0.7,7-1,7c-0.3,0-0.6-3-0.7-7c-0.1-1.9-0.1-4.6-0.1-7 C57.4,61.5,57.5,56,57.6,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M57.7,51.2c0.1-4.3,0.3-10.3,0.5-13.8c0.2-2.2,0.2-5.2,0.3-6.9c0.2-3.6,0.5-6.8,0.8-6.8 c0.3,0,0.6,3.2,0.8,6.9c0.1,1.7,0.2,4.7,0.2,6.9c0,3.5-0.1,9.5-0.2,13.8C60,55.6,59.8,61.6,59.6,65c-0.1,2.2-0.3,5.2-0.4,6.9 c-0.3,3.6-0.7,6.8-1,6.8c-0.3,0-0.5-3.2-0.6-6.9c-0.1-1.7-0.1-4.7-0.1-6.9C57.5,61.5,57.6,55.5,57.7,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M57.8,51.2c0.1-3.8,0.3-10.4,0.5-13.4l0.1-1.7c0-0.6,0.1-1.2,0.1-1.9c0-1.2,0.1-2.4,0.1-3.2 c0.2-3.2,0.4-6.7,0.7-6.7c0.3,0,0.5,3.5,0.7,6.7c0,0.7,0.1,1.9,0.1,3.2c0,0.6,0,1.3,0,1.9l0,1.7c0,3.1-0.1,9.6-0.2,13.5 c-0.1,3.8-0.3,10.4-0.5,13.5c-0.1,2-0.3,5.2-0.4,6.7c-0.3,3.2-0.6,6.7-0.9,6.7c-0.3,0-0.4-3.5-0.5-6.7c0-1.5,0-4.8-0.1-6.7 C57.6,61.6,57.7,55,57.8,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M57.9,51.2c0.1-3.3,0.3-10.4,0.5-13.1c0-0.9,0.1-2.2,0.2-3.4c0-1.3,0.1-2.5,0.1-3.1 c0.2-2.8,0.4-6.5,0.6-6.5c0.2,0,0.5,3.7,0.6,6.5c0,0.7,0.1,1.9,0.1,3.1c0,1.3,0,2.6,0,3.4c0,2.7-0.1,9.8-0.2,13.1 c-0.1,3.3-0.3,10.4-0.5,13.1c-0.1,1.7-0.3,5.3-0.4,6.6c-0.2,2.8-0.6,6.5-0.8,6.5c-0.2,0-0.4-3.7-0.5-6.5c0-1.3,0-4.8,0-6.6 C57.7,61.7,57.8,54.6,57.9,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M58,51.2c0.1-2.9,0.3-10.5,0.5-12.8l0.2-3.3c0-1.3,0.1-2.5,0.1-3.1c0.1-2.4,0.3-6.4,0.5-6.4 c0.2,0,0.4,4,0.6,6.4c0,0.6,0.1,1.8,0.1,3.1l0,3.3c0,2.3-0.1,10-0.2,12.8c-0.1,2.9-0.3,10.5-0.5,12.8c-0.1,1.5-0.2,5.3-0.3,6.4 c-0.2,2.4-0.5,6.4-0.7,6.4c-0.2,0-0.3-4-0.4-6.4c0-1.1,0-4.9,0-6.4C57.8,61.7,57.9,54.1,58,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M58.1,51.2c0.1-2.4,0.3-10.6,0.4-12.5l0.1-3.2c0.1-1.3,0.1-2.5,0.1-3c0.1-2,0.3-6.2,0.5-6.2 c0.2,0,0.4,4.2,0.5,6.2c0,0.5,0.1,1.7,0.1,3l0,3.2c0,1.9-0.1,10.1-0.2,12.5c-0.1,2.4-0.3,10.6-0.4,12.5c-0.1,1.2-0.2,5.3-0.3,6.2 c-0.2,2-0.5,6.2-0.6,6.2C58,76.2,58,72,57.9,70c0-0.9,0-5,0-6.2C57.9,61.8,58,53.6,58.1,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M58.2,51.2c0-1.9,0.3-10.6,0.4-12.2l0.1-3.1l0-1l0-0.9c0-0.5,0-0.9,0-1.1c0.1-1.6,0.2-6.1,0.4-6.1 c0.1,0,0.3,4.4,0.4,6.1c0,0.2,0,0.6,0,1.1l0,0.9l0,1l0,3.1c0,1.5-0.2,10.3-0.2,12.2c0,1.9-0.3,10.6-0.4,12.2 c-0.1,1-0.2,5.3-0.3,6.1c-0.1,1.6-0.4,6.1-0.5,6.1c-0.1,0-0.2-4.5-0.2-6.1c0-0.7,0-5.1,0-6.1C58,61.9,58.2,53.1,58.2,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M58.3,51.2c0-1.4,0.3-10.7,0.4-11.8c0-0.7,0.2-5.4,0.2-5.9c0.1-1.2,0.2-5.9,0.3-5.9c0.1,0,0.3,4.7,0.3,5.9 c0.1,0.6,0,5.2,0,5.9c0,1.2-0.2,10.4-0.2,11.9c0,1.4-0.3,10.7-0.4,11.8c0,0.7-0.2,5.4-0.2,5.9c-0.1,1.2-0.4,5.9-0.5,5.9 c-0.1,0-0.1-4.7-0.2-5.9c0-0.6,0.1-5.2,0-5.9C58.1,61.9,58.3,52.7,58.3,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M58.4,51.2c0-1,0.3-10.8,0.4-11.5l0.1-2.9l0.1-1.8c0-0.5,0-0.9,0-1c0-0.8,0.2-5.8,0.2-5.8 c0.1,0,0.2,4.9,0.2,5.8c0,0.1,0,0.5,0,1l0,1.8l0,2.9c0,0.8-0.2,10.6-0.2,11.5c0,1-0.3,10.8-0.4,11.5c0,0.5-0.2,5.4-0.2,5.8 c-0.1,0.8-0.3,5.8-0.4,5.7c-0.1,0-0.1-4.9-0.1-5.8c0-0.4,0.1-5.3,0.1-5.8C58.2,62,58.4,52.2,58.4,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M58.5,51.2L58.9,40c0-0.2,0.2-5.4,0.2-5.6c0-0.4,0.1-5.6,0.1-5.6c0,0,0.1,5.2,0.2,5.6 c0,0.2-0.1,5.4-0.1,5.6L59,51.2l-0.3,11.2l-0.2,5.6c0,0.4-0.3,5.6-0.3,5.6c0,0,0-5.2,0-5.6l0.1-5.6L58.5,51.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.2,73 58.3,67.6 58.4,62.1 58.6,51.2 58.9,40.4 59.1,34.9 59.2,29.5 59.2,34.9 59.1,40.4 58.9,51.2 58.6,62.1  58.4,67.6  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.591510e-02 1.591510e-02 0.9999 -1.9527 1.3277)",
    className: "st48",
    cx: 82.4,
    cy: 123.3,
    rx: 1.4,
    ry: 16.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M81.1,123.4c0-2.8,0-5.9,0.1-8.2c0-1.4,0.1-3,0.2-4.1c0.2-2.3,0.5-4.1,0.8-4.1c0.3,0,0.7,1.7,0.9,4 c0.1,1.1,0.2,2.6,0.3,4.1c0.1,2.2,0.3,5.4,0.3,8.2c0,2.8,0,5.9-0.1,8.2c0,1.4-0.1,3-0.2,4.1c-0.2,2.3-0.5,4.1-0.8,4.1 c-0.3,0-0.7-1.7-0.9-4c-0.1-1.1-0.2-2.6-0.3-4.1C81.3,129.3,81.1,126.1,81.1,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M81.2,123.4c0-2.5,0-6,0-8c0-1.3,0.1-3,0.2-4c0.2-2.1,0.4-4,0.7-4c0.3,0,0.6,1.8,0.9,3.9 c0.1,1,0.2,2.7,0.3,4c0.1,2,0.3,5.5,0.3,8c0,2.5,0,6,0,8c0,1.3-0.1,3-0.2,4c-0.2,2.1-0.4,4-0.7,4c-0.3,0-0.6-1.8-0.9-3.9 c-0.1-1-0.2-2.7-0.3-4C81.4,129.3,81.2,125.9,81.2,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M81.3,123.4c0-2.2,0-6,0-7.8c0-1.1,0.1-3,0.2-3.9c0.2-1.9,0.4-3.9,0.6-3.9c0.3,0,0.6,2,0.8,3.9 c0.1,0.9,0.2,2.7,0.3,3.9c0.1,1.8,0.2,5.6,0.3,7.8c0,2.2,0,6,0,7.8c0,1.1-0.1,3-0.2,3.9c-0.2,1.9-0.4,3.9-0.7,3.9 c-0.3,0-0.6-2-0.8-3.9c-0.1-0.9-0.2-2.7-0.3-3.9C81.5,129.4,81.3,125.6,81.3,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M81.4,123.4c0-1.9,0-6,0-7.6c0-1,0.1-3,0.1-3.8c0.1-1.6,0.3-3.8,0.6-3.8c0.2,0,0.5,2.1,0.7,3.8 c0.1,0.8,0.2,2.8,0.3,3.8c0.1,1.6,0.2,5.7,0.3,7.6c0,1.9,0,6,0,7.6c0,1-0.1,3-0.1,3.8c-0.1,1.6-0.3,3.8-0.6,3.8 c-0.2,0-0.5-2.1-0.7-3.8c-0.1-0.8-0.2-2.8-0.3-3.8C81.6,129.4,81.4,125.3,81.4,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M81.5,123.4c0-1.7,0-6.1,0-7.4c0-0.9,0.1-3.1,0.1-3.7c0.1-1.4,0.3-3.7,0.5-3.7c0.2,0,0.5,2.3,0.6,3.7 c0.1,0.6,0.2,2.8,0.2,3.7c0.1,1.3,0.2,5.8,0.2,7.4c0,1.7,0,6.1,0,7.4c0,0.9-0.1,3.1-0.1,3.7c-0.1,1.4-0.3,3.7-0.5,3.7 c-0.2,0-0.5-2.3-0.6-3.7c-0.1-0.6-0.2-2.8-0.2-3.7C81.7,129.4,81.5,125,81.5,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M81.6,123.4c0-1.4,0-6.1,0-7.2c0-0.7,0-3.1,0.1-3.6c0.1-1.2,0.2-3.6,0.4-3.6c0.2,0,0.4,2.4,0.5,3.6 c0.1,0.5,0.2,2.9,0.2,3.6c0.1,1.1,0.2,5.8,0.2,7.2c0,1.4,0,6.1,0,7.2c0,0.7,0,3.1-0.1,3.6c-0.1,1.2-0.2,3.6-0.4,3.6 c-0.2,0-0.4-2.4-0.5-3.6c-0.1-0.5-0.2-2.9-0.2-3.6C81.8,129.5,81.6,124.7,81.6,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M81.7,123.4c0-1.1,0-6.1,0-7c0-0.6,0-3.1,0.1-3.5c0.1-0.9,0.2-3.5,0.3-3.5c0.1,0,0.3,2.6,0.4,3.5 c0,0.4,0.1,2.9,0.2,3.5c0.1,0.9,0.2,5.9,0.2,7c0,1.1,0,6.1,0,7c0,0.6,0,3.1-0.1,3.5c-0.1,0.9-0.2,3.5-0.3,3.5 c-0.1,0-0.3-2.6-0.4-3.5c0-0.4-0.1-2.9-0.2-3.5C81.9,129.5,81.7,124.5,81.7,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M81.8,123.4c0-0.8,0-6.2,0-6.9c0-0.4,0-3.1,0-3.4c0.1-0.7,0.2-3.4,0.3-3.4c0.1,0,0.3,2.7,0.4,3.4 c0,0.3,0.1,3,0.2,3.4c0,0.7,0.2,6,0.2,6.9c0,0.8,0,6.2,0,6.9c0,0.4,0,3.1,0,3.4c-0.1,0.7-0.2,3.4-0.3,3.4c-0.1,0-0.3-2.7-0.4-3.4 c0-0.3-0.1-3-0.2-3.4C82,129.5,81.8,124.2,81.8,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M81.9,123.4c0-0.6,0-6.2,0-6.7c0-0.3,0-3.1,0-3.3c0-0.5,0.1-3.3,0.2-3.3c0.1,0,0.2,2.9,0.3,3.3 c0,0.2,0.1,3,0.1,3.3c0,0.4,0.2,6.1,0.2,6.7c0,0.6,0,6.2,0,6.7c0,0.3,0,3.1,0,3.3c0,0.5-0.1,3.3-0.2,3.3c-0.1,0-0.2-2.9-0.3-3.3 c0-0.2-0.1-3-0.1-3.3C82.1,129.6,81.9,123.9,81.9,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M82,123.4l0-6.5l0-3.2c0-0.2,0.1-3.2,0.1-3.2c0,0,0.2,3,0.2,3.2l0.1,3.2l0.2,6.5l0,6.5l0,3.2 c0,0.2-0.1,3.2-0.1,3.2c0,0-0.2-3-0.2-3.2l-0.1-3.2L82,123.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.5,135.9 82.3,132.8 82.3,129.7 82.1,123.4 82.1,117.1 82,113.9 82.1,110.8 82.2,113.9 82.3,117.1 82.4,123.4  82.5,129.6 82.5,132.8  "
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M5,62.1c0.1-0.2,7.6,3.7,19.7,10.2l4.7,2.5c0.8,0.4,1.7,0.9,2.5,1.4l2.6,1.5L45.7,84l25.5,14.7l10.9,6.3 l21.2-12.1c1.6-0.9,3.2-1.8,4.8-2.7l4.5-2.4l8.1-4.3c9.9-5.3,15.9-8.4,16-8.2c0.1,0.2-5.8,3.5-15.5,9l-8,4.5l-4.5,2.5 c-1.5,0.9-3.1,1.8-4.7,2.8l-21.8,12.7L70.5,100L45.1,85.2L34,78.7l-2.6-1.5c-0.8-0.5-1.7-0.9-2.5-1.4l-4.7-2.6 C12.3,66.5,5,62.3,5,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M71.2,98.7l11,6.3l20.5-11.7l4.3-2.4c0.7-0.4,1.4-0.8,2.2-1.2l2.1-1.2l7.6-4.1c9.4-5,16.3-8.6,16.3-8.5 c0.1,0.1-6.6,4-15.9,9.2l-7.6,4.2l-2.1,1.2c-0.7,0.4-1.4,0.8-2.2,1.2l-4.3,2.5l-21.1,12.3l-11.6-6.7c-10.9-6.3-23.3-13.5-32-18.6 l-4.3-2.5l-2.1-1.3c-0.7-0.4-1.4-0.8-2.1-1.2l-7.6-4.2c-9.3-5.2-16-9.1-15.9-9.2c0.1-0.1,7,3.4,16.4,8.4l7.6,4.1 c0.7,0.4,1.4,0.8,2.1,1.2l2.2,1.2l4.3,2.4C47.9,85.3,60.4,92.5,71.2,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M71.2,98.8l11,6.4L102,93.8l4.1-2.3c0.7-0.4,1.4-0.8,2.1-1.2l2.2-1.2l7.5-4c8.5-4.5,15.9-8.4,16-8.3 c0.1,0.1-7.2,4.3-15.6,9l-7.4,4.1l-2.1,1.2c-0.7,0.4-1.4,0.8-2.1,1.2l-4,2.4l-20.3,11.8l-11.6-6.7c-9.8-5.6-23.4-13.6-31.3-18.2 L31,76.8l-7.4-4.1C15.2,68,7.9,63.9,8,63.7c0.1-0.1,7.5,3.8,16,8.3l7.5,4l8.3,4.7C47.7,85.3,61.4,93.1,71.2,98.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M71.2,98.8l11,6.4l19.1-10.9l3.8-2.2c1.4-0.8,2.8-1.6,4.3-2.4l7.4-4c7.5-4,15.5-8.3,15.6-8.1 c0.1,0.1-7.8,4.6-15.2,8.8l-7.3,4.1c-1.4,0.8-2.9,1.6-4.3,2.4l-3.8,2.2l-19.5,11.4l-11.6-6.7C61.9,94.8,47,86.1,40.1,82l-8-4.7 L31,76.7l-1-0.6l-2-1.1l-3.2-1.8c-7.4-4.2-15.3-8.6-15.3-8.7c0.1-0.1,8.1,4.1,15.6,8.1l3.3,1.7l2,1.1l1.1,0.6l1.1,0.6l8.1,4.6 C47.5,85.2,62.5,93.8,71.2,98.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M71.1,98.9l11,6.4l18.4-10.5c2-1.1,5-2.9,7.9-4.5l7.2-3.9c6.6-3.5,15.2-8.1,15.2-8 c0.1,0.1-8.4,4.9-14.9,8.5l-7.2,4c-2.9,1.6-5.8,3.4-7.8,4.5l-18.8,10.9l-11.5-6.6L40.8,82.4L33,77.9l-2.1-1.2l-2-1.1l-3.1-1.7 c-6.5-3.6-15-8.4-14.9-8.5c0.1-0.1,8.6,4.5,15.2,8l3.1,1.7l2,1.1l2.1,1.2l7.8,4.5L71.1,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M71.1,98.9l11.1,6.4l17.7-10.1l7.6-4.3c2.9-1.6,5.8-3.1,7.1-3.8c5.6-3,14.8-7.9,14.8-7.8 c0,0.1-9,5.2-14.6,8.3l-7,3.9l-7.6,4.4l-18,10.5l-11.5-6.6L41.6,82.8c-3.4-2-12-7-14.6-8.4c-5.6-3.1-14.6-8.2-14.6-8.3 c0-0.1,9.2,4.8,14.8,7.8c2.6,1.3,11.3,6.3,14.7,8.2L71.1,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M71.1,99l11.1,6.4l17-9.7l7.4-4.2c1.5-0.9,2.9-1.6,4.2-2.3l2.8-1.5c4.7-2.5,14.4-7.7,14.5-7.6 c0,0.1-9.6,5.5-14.2,8.1l-2.7,1.5c-1.2,0.7-2.7,1.5-4.2,2.3l-7.3,4.3l-17.3,10l-11.5-6.6L42.3,83.2L35,78.9l-4.1-2.4L28.1,75 c-4.6-2.6-14.3-8-14.2-8c0-0.1,9.8,5.1,14.5,7.6l2.8,1.5l4.1,2.4l7.4,4.2L71.1,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M71.1,99l11.1,6.4l16.2-9.3l7.1-4.1l2.2-1.3l2-1.1l2.6-1.4c3.8-2,14-7.5,14.1-7.5c0,0.1-10.2,5.7-13.9,7.8 L110,90l-2,1.1l-2.2,1.3l-7.1,4.1l-16.5,9.6l-11.4-6.6l-27.7-16L36,79.4L31.8,77c-0.6-0.4-1.1-0.7-1.6-0.9l-1-0.6 c-3.7-2.1-13.9-7.8-13.9-7.8c0-0.1,10.3,5.5,14.1,7.5l1,0.5c0.4,0.2,1,0.5,1.6,0.9l4.2,2.4l7.1,4.1L71.1,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M71,99.1l11.1,6.4l15.5-8.9c1.7-1,12.2-7,13.5-7.7c2.8-1.5,13.7-7.4,13.7-7.3c0,0-10.8,6-13.5,7.6 c-1.3,0.6-11.8,6.8-13.5,7.7l-15.7,9.1l-11.4-6.6L43.9,83.9l-6.9-4l-4.2-2.4l-1.5-0.9l-0.9-0.5c-2.8-1.6-13.6-7.5-13.6-7.6 c0,0,10.9,5.8,13.7,7.3c0.2,0.1,0.5,0.2,0.9,0.5l1.5,0.9l4.2,2.4l6.9,4L71,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M71,99.1l11.2,6.5L97,97l6.7-3.8l4.2-2.4l2.3-1.2c1.9-1,13.3-7.2,13.3-7.2c0,0-11.3,6.3-13.2,7.4L108,91 l-4.2,2.4l-6.6,3.9l-15,8.7l-11.4-6.5L44.6,84.3l-13.1-7.6c-1.8-1.1-13.2-7.3-13.2-7.4c0,0,11.4,6.1,13.3,7.2L44.8,84L71,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M71,99.1l11.2,6.5l14.1-8.1l6.4-3.7l4.2-2.4c1.2-0.7,2-1.1,2.1-1.2l12.9-7l-12.9,7.1 c-0.1,0.1-0.9,0.5-2.1,1.2l-4.2,2.4l-6.4,3.7l-14.2,8.2l-11.3-6.5L45.4,84.6l-12.7-7.4c-0.2-0.1-1.1-0.7-2.4-1.4l-4.4-2.4 c-3.1-1.7-6.1-3.4-6.1-3.4c0,0,3,1.6,6.1,3.3l4.4,2.4c1.3,0.7,2.2,1.2,2.4,1.3l12.8,7.3L71,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3,70.9l6.3,3.4l3.1,1.7c1,0.6,2.1,1.2,3.1,1.8l12.4,7.1L71,99.2l11.2,6.5L95.6,98l12.4-7.1l12.6-6.8L108,90.9 L95.6,98l-13.5,7.8l-11.3-6.5L46.1,85l-12.4-7.2c-1-0.6-2.1-1.2-3.1-1.8l-3.1-1.7L21.3,70.9z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st61"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M132.6,64.8c-0.3,0.5-28.2-15.1-62.4-34.8l-10.9-6.3l-9.9,5.7l-9.6,5.5c-6.1,3.5-11.5,6.5-16.1,9 c-9.1,5-14.7,8-14.8,7.7C8.8,51.3,14.1,48,23,42.6c4.5-2.7,9.8-5.9,15.9-9.4l9.5-5.6l10.9-6.4l12,6.9 C105.4,47.8,132.9,64.2,132.6,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M70.2,29.9l-10.9-6.3L49.8,29l-8.9,5c-5.3,3-11.2,6.3-15.2,8.6c-8.8,4.9-15.2,8.3-15.4,8.1 c-0.1-0.2,6.1-4.1,14.7-9.3c4-2.4,9.8-5.8,15-8.9l8.8-5.2l10.5-6.1l11.9,6.9c10.3,5.9,22,12.8,30.2,17.6c5.3,3.1,11.1,6.5,15,8.9 c8.6,5.2,14.8,9,14.7,9.3c-0.1,0.2-6.6-3.2-15.4-8.1c-4.1-2.3-9.9-5.5-15.2-8.6C92.3,42.6,80.5,35.8,70.2,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M70.3,29.9l-11-6.4l-9.4,5.4l-8.4,4.7C36.8,36.4,30.3,40,26.7,42c-7.9,4.4-14.9,8.2-15,8 c-0.1-0.2,6.7-4.3,14.4-9c3.6-2.2,10-5.9,14.7-8.7l8.3-4.9l10.3-6l11.9,6.8c9.2,5.3,22.1,12.8,29.5,17.2 c4.7,2.8,11.1,6.6,14.7,8.7c7.8,4.7,14.5,8.8,14.4,9c-0.1,0.2-7.1-3.6-15-8c-3.7-2-10.1-5.7-14.9-8.4 C92.5,42.6,79.5,35.2,70.3,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M70.3,29.8l-11-6.4l-17.1,9.8c-4.3,2.4-11.3,6.4-14.5,8.2c-7,3.9-14.5,8-14.6,7.8 c-0.1-0.2,7.2-4.6,14.1-8.8c3.2-1.9,10.1-6,14.4-8.5l7.8-4.5l10.1-5.8l11.8,6.8c8.2,4.7,22.3,12.9,28.9,16.8 c4.2,2.5,11.2,6.6,14.4,8.5c6.9,4.1,14.2,8.6,14.1,8.8c-0.1,0.2-7.6-3.9-14.6-7.8c-3.2-1.8-10.3-5.8-14.5-8.2 C92.6,42.6,78.5,34.5,70.3,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M70.4,29.7l-11-6.4l-16.5,9.4c-3.7,2.1-11.3,6.4-14.2,8c-6.2,3.4-14.2,7.8-14.3,7.7 c-0.1-0.2,7.8-4.9,13.8-8.5c2.8-1.7,10.3-6.1,14-8.3l7.2-4.2l9.8-5.7l11.8,6.8c7.2,4.1,22.4,13,28.2,16.4 c3.7,2.2,11.2,6.6,14,8.3c6,3.6,13.9,8.4,13.8,8.5c-0.1,0.2-8.1-4.3-14.3-7.7c-2.8-1.6-10.4-5.9-14.2-8 C92.8,42.6,77.5,33.9,70.4,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M70.4,29.7l-11.1-6.4l-15.8,9c-3.2,1.8-11.4,6.5-13.8,7.8c-5.3,2.9-13.8,7.7-13.9,7.6 c-0.1-0.1,8.3-5.2,13.5-8.3c2.4-1.4,10.5-6.2,13.7-8.1l16.3-9.5L71,28.5c6.2,3.6,22.5,13.1,27.5,16c3.2,1.9,11.3,6.6,13.7,8.1 c5.2,3.1,13.6,8.1,13.5,8.3c-0.1,0.1-8.6-4.6-13.9-7.6c-2.4-1.4-10.6-6-13.8-7.8C93,42.6,76.6,33.2,70.4,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M70.4,29.6l-11.1-6.4l-15.1,8.7c-2.7,1.5-11.4,6.5-13.5,7.6c-4.4,2.4-13.5,7.5-13.5,7.4 c-0.1-0.1,8.9-5.4,13.2-8c2-1.2,10.7-6.3,13.4-7.8l15.6-9.1L71,28.6c5.1,3,22.7,13.1,26.8,15.6c2.6,1.6,11.4,6.6,13.4,7.8 c4.3,2.6,13.3,7.9,13.2,8c-0.1,0.1-9.2-5-13.5-7.4c-2-1.1-10.8-6.1-13.5-7.6C93.2,42.7,75.6,32.6,70.4,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M70.5,29.5l-11.2-6.5l-14.5,8.3l-13.1,7.5c-3.5,2-13.1,7.4-13.2,7.3c0-0.1,9.4-5.7,12.9-7.8l13-7.6L59.3,22 l11.6,6.7L97,43.9l13,7.6c3.4,2.1,12.9,7.7,12.9,7.8c0,0.1-9.7-5.3-13.2-7.3l-13.1-7.5L70.5,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M70.5,29.5L59.3,23l-13.8,7.9l-12.8,7.3c-2.6,1.5-12.8,7.2-12.8,7.1c0-0.1,10-6,12.6-7.5l12.7-7.4l14.1-8.2 l11.6,6.7l25.4,14.8L109,51c2.6,1.6,12.6,7.5,12.6,7.5c0,0.1-10.2-5.7-12.8-7.1L96,44.1L70.5,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M70.5,29.4l-11.2-6.5l-13.2,7.6l-12.4,7.1c-1.8,1-12.4,7-12.5,7c0,0,10.6-6.3,12.3-7.3L45.9,30l13.4-7.8 l11.5,6.6l24.7,14.3l12.4,7.2c1.7,1,12.3,7.2,12.3,7.3c0,0-10.7-6-12.5-7l-12.4-7.1L70.5,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M70.6,29.3l-11.3-6.5L46.8,30l-12.1,6.9c-0.9,0.5-12.1,6.9-12.1,6.8c0,0,11.1-6.5,12-7l12-7l12.7-7.3 L70.8,29l24.1,13.9l12,7c0.9,0.5,12,7,12,7c0,0-11.2-6.4-12.1-6.8l-12.1-6.9L70.6,29.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "117.5,56.2 105.7,49.5 94,42.7 70.6,29.3 59.3,22.7 47.5,29.5 35.8,36.3 24,43 35.7,36.2  47.4,29.4 59.3,22.5 70.7,29.1 94.1,42.6 105.8,49.4  "
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M5.6,53.9C6.4,52.5,36.2,68.2,72.2,89l5.8,3.3l2.8,1.7l1.4,0.8l0,0l9.7-5.5c3.6-2,7-3.9,10.3-5.7 c6.6-3.6,12.4-6.7,17.4-9.3c9.9-5.1,16-7.9,16.3-7.3c0.4,0.6-5.1,4.5-14.5,10.5c-4.7,3-10.3,6.5-16.7,10.4 c-3.2,1.9-6.6,4-10.1,6.1l-5.4,3.2l-2.8,1.6l-4.2,2.5L69.3,94C33.3,73.2,4.8,55.2,5.6,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M72.1,89.2l5.6,3.3l2.9,1.7L82,95l0.1,0.1l9.6-5.4c3.5-2,6.8-3.8,9.7-5.4c5.7-3.1,11.9-6.5,16.2-8.7 c9.4-4.9,16.4-8.2,16.7-7.6c0.3,0.6-6,5-15,10.7c-4.1,2.6-10.2,6.3-15.7,9.7c-2.8,1.7-6.1,3.7-9.5,5.7L89,97.1l-2.7,1.6l-4,2.4 l-12.7-7.3C58.6,87.5,46.3,80.2,37.7,75C32.2,71.7,26.2,68,22,65.3C13.1,59.6,6.7,55.2,7,54.7c0.3-0.6,7.3,2.7,16.7,7.6 c4.3,2.3,10.6,5.6,16.2,8.7C48.8,75.9,61.3,82.9,72.1,89.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M72,89.3l5.5,3.2l2.9,1.7l1.5,0.9l0.3,0.2l9.5-5.4c3.4-1.9,6.6-3.7,9.1-5.1c5.1-2.8,11.9-6.5,15.8-8.6 c8.5-4.4,16-8.1,16.3-7.6c0.3,0.5-6.7,5.2-14.7,10.3c-3.7,2.4-10.4,6.4-15.3,9.4c-2.5,1.5-5.6,3.4-9,5.4l-5.2,3.1L86,98.5 l-3.9,2.3l-12.6-7.2c-9.7-5.6-23.3-13.6-31-18.3c-5-3-11.6-7.1-15.3-9.4c-8-5.1-15-9.8-14.7-10.3c0.3-0.5,7.8,3.2,16.3,7.6 c3.9,2,10.7,5.8,15.8,8.6C48.6,76,62.2,83.7,72,89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M71.9,89.5l5.3,3.1l3,1.7l1.5,0.9l0.4,0.3l9.5-5.3c3.3-1.9,6.3-3.6,8.6-4.8c4.5-2.5,12-6.6,15.5-8.4 c7.5-3.9,15.6-8,15.9-7.5c0.3,0.5-7.3,5.4-14.4,10c-3.3,2.1-10.6,6.5-15,9.2c-2.2,1.3-5.1,3.1-8.4,5l-5.1,3l-6.4,3.7l-12.5-7.1 c-8.6-5-23.4-13.7-30.3-17.9c-4.4-2.7-11.7-7.1-15-9.2c-7.2-4.6-14.7-9.5-14.4-10c0.3-0.5,8.3,3.6,15.9,7.5 c3.5,1.8,10.9,5.9,15.4,8.4C48.3,76.1,63.2,84.5,71.9,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M71.8,89.7l5.2,3l3,1.8l1.6,0.9l0.6,0.4l9.4-5.3c3.2-1.8,6.1-3.4,8-4.5c4-2.2,12-6.7,15.1-8.2 c6.6-3.4,15.2-7.8,15.4-7.4c0.2,0.4-7.9,5.6-14.2,9.6c-2.9,1.8-10.8,6.6-14.7,8.9c-1.9,1.1-4.7,2.8-7.9,4.7l-5.1,3l-6.1,3.6 l-12.3-7.1c-7.6-4.4-23.6-13.7-29.6-17.4c-3.9-2.3-11.8-7.1-14.7-8.9c-6.3-4-14.4-9.2-14.2-9.6c0.2-0.4,8.8,4,15.4,7.4 c3,1.6,11.1,6.1,15.1,8.2C48.1,76.2,64.2,85.3,71.8,89.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M71.7,89.9l5,2.9l3.1,1.8l1.6,1l0.8,0.5l9.3-5.3c3.2-1.8,5.8-3.3,7.4-4.2c3.4-1.9,12.1-6.7,14.7-8.1 c5.6-2.9,14.8-7.7,15-7.4c0.2,0.3-8.5,5.9-13.9,9.3c-2.5,1.6-11,6.7-14.3,8.7c-1.6,0.9-4.2,2.5-7.3,4.4l-10.9,6.4l-12.2-7 c-6.5-3.7-23.7-13.8-28.9-17c-3.3-2-11.8-7.1-14.3-8.7c-5.4-3.4-14.1-8.9-13.9-9.3c0.2-0.3,9.4,4.4,15,7.4 c2.6,1.4,11.3,6.2,14.7,8.1C47.8,76.3,65.2,86.1,71.7,89.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M71.6,90l10.6,6.2l9.3-5.2c3.1-1.7,5.6-3.1,6.9-3.9c2.8-1.6,12.1-6.8,14.3-7.9c4.7-2.4,14.4-7.6,14.6-7.3 c0.2,0.3-9.1,6.1-13.6,9c-2.1,1.3-11.2,6.7-14,8.4c-1.3,0.8-3.8,2.2-6.8,4l-10.6,6.2l-12.1-6.9c-5.4-3.1-23.9-13.9-28.2-16.5 c-2.8-1.7-11.9-7.1-14-8.4c-4.5-2.8-13.8-8.7-13.6-9c0.2-0.3,9.9,4.9,14.6,7.3c2.2,1.1,11.5,6.4,14.3,7.9 C47.6,76.3,66.2,86.9,71.6,90z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M71.5,90.2l10.7,6.2l9.2-5.2c3-1.7,5.3-3,6.3-3.6c2.3-1.2,12.2-6.8,13.9-7.7c3.8-2,14-7.5,14.1-7.2 c0.1,0.2-9.8,6.3-13.3,8.6c-1.7,1.1-11.4,6.8-13.6,8.2c-1,0.6-3.3,2-6.2,3.7l-10.3,6l-11.9-6.8c-4.3-2.5-24-14-27.4-16.1 c-2.2-1.3-12-7.1-13.6-8.2c-3.6-2.3-13.5-8.4-13.3-8.6c0.1-0.2,10.4,5.3,14.1,7.2c1.7,0.9,11.6,6.5,13.9,7.7 C47.4,76.4,67.1,87.7,71.5,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M71.4,90.4l10.8,6.3l9.1-5.2c2.8-1.6,5-2.9,5.8-3.3c1.7-0.9,12.2-6.9,13.5-7.6c2.8-1.5,13.6-7.4,13.7-7.2 c0.1,0.2-10.4,6.6-13.1,8.3c-1.2,0.8-11.7,6.9-13.3,7.9c-0.7,0.4-2.9,1.7-5.7,3.4l-10,5.8l-11.8-6.8 c-3.2-1.9-24.1-14.1-26.7-15.6c-1.7-1-12.1-7.1-13.3-7.9c-2.7-1.7-13.2-8.1-13.1-8.3c0.1-0.2,10.9,5.7,13.7,7.2 c1.3,0.7,11.8,6.6,13.5,7.6C47.1,76.5,68.1,88.5,71.4,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M71.3,90.6l10.9,6.4l9-5.1l5.2-3c1.1-0.6,12.3-6.9,13.1-7.4c1.9-1,13.2-7.2,13.3-7.1 c0.1,0.1-11,6.8-12.8,7.9c-0.8,0.5-11.9,7-13,7.7L91.8,93l-9.6,5.6l-11.7-6.7c-2.2-1.2-24.3-14.2-26-15.2 c-1.1-0.7-12.1-7.1-13-7.7c-1.8-1.1-12.9-7.8-12.8-7.9c0.1-0.1,11.4,6.1,13.3,7.1c0.9,0.5,12,6.8,13.1,7.4 C46.9,76.6,69.1,89.3,71.3,90.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M71.2,90.8l11,6.4l13.6-7.8l12.7-7.2c0.9-0.5,12.8-7.1,12.8-7.1c0,0.1-11.6,7-12.5,7.6l-12.6,7.4l-14,8.2 l-11.5-6.6L45.3,76.9l-12.6-7.4c-0.9-0.6-12.6-7.5-12.5-7.6c0-0.1,11.9,6.6,12.8,7.1l12.7,7.2L71.2,90.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "21.6,62.7 34,69.7 46.4,76.8 71.1,90.9 82.2,97.4 95.1,90 107.5,82.9 119.9,75.9 107.6,83.2  95.3,90.3 82.2,98 70.8,91.5 46.2,77.1 33.9,70  "
  })))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M80.3,40.6c0.2,0.4,0.3,1.2-0.2,1.5l-0.7,0.4c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0-0.7-0.1-1 c-0.2-0.5-0.8-1.3-1.4-1.4c-0.1,0-0.2,0-0.3,0l0,0l0.7-0.4c0.4-0.2,0.9,0.1,1.1,0.3C79.9,39.8,80.1,40.2,80.3,40.6z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M109.6,58c0,0.3,0,0.7-0.3,0.9l-0.7,0.4l0,0c0,0,0.1-0.1,0.1-0.1c0.4-0.5,0-1.5-0.3-1.9 c-0.2-0.3-0.4-0.5-0.7-0.7c-0.2-0.1-0.5-0.2-0.7-0.1l0.7-0.4c0.3-0.2,0.7,0,1,0.2c0.3,0.2,0.5,0.5,0.7,0.8 C109.5,57.3,109.6,57.6,109.6,58z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M26.3,71.7c0.2,0.4,0.3,1.2-0.2,1.5l-0.6,0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0-0.7-0.1-1 c-0.2-0.5-0.7-1.3-1.4-1.4c-0.1,0-0.2,0-0.3,0l0,0l0.5-0.3c0.4-0.2,0.9,0.1,1.1,0.3C25.9,71,26.1,71.3,26.3,71.7z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M55.6,89.2c0,0.3,0,0.7-0.3,0.9l-0.5,0.3l0,0c0,0,0.1-0.1,0.1-0.1c0.4-0.6,0-1.5-0.3-1.9 c-0.2-0.3-0.4-0.5-0.7-0.7c-0.2-0.1-0.5-0.2-0.7-0.1l0.6-0.3c0.3-0.2,0.7,0,1,0.2c0.3,0.2,0.5,0.5,0.7,0.8 C55.5,88.5,55.6,88.8,55.6,89.2z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M30.8,73.9c-0.4,0.3-1,0.3-1.6,0.1l0.6-0.3c0.8-0.5,0.9-1.6,0.8-2.3c-0.1-0.5-0.2-1-0.4-1.5 c-0.3-0.7-0.7-1.2-1.1-1.8c-0.5-0.8-1.1-1.5-1.6-2.3c1.9,0.3,3.5,2.6,4,4.1c0.3,0.9,0.5,2,0.2,2.9C31.5,73.3,31.2,73.7,30.8,73.9 C30.9,73.9,30.9,73.9,30.8,73.9z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M30.1,63.8c0.9-0.5,2,0,2.7,0.5c0.8,0.6,1.4,1.3,1.9,2.2L30.1,63.8L30.1,63.8z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M55.7,82.7c0.6-0.2,1.4-0.1,2.2,0.4c-0.2,0.1-0.5,0.1-0.7,0.2c-0.4,0.1-1.7,0.3-2,0.5l-0.6,0.3 C54.7,83.4,55.1,83,55.7,82.7C55.6,82.7,55.7,82.7,55.7,82.7z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M59.3,80.6c0.6-0.4,1.4-0.2,2,0.1c0.7,0.3,1.2,0.7,1.6,1.3c-0.3,0.1-0.7,0.2-1,0.2L59.3,80.6L59.3,80.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.1138,
    y1: 17.5492,
    x2: 35.5526,
    y2: 23.7529
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4182,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5449,
    style: {
      stopColor: "#C0C0C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6823,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    style: {
      stopColor: "#7F7F7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787878"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M61.5,3.9c0.6,0.8,1.1,1.9,1,2.9c0,0.4-0.2,0.9-0.6,1.2l-1.6,0.9L8.1,39c-0.3-0.5-0.7-0.9-1-1.4 c-0.6-0.8-1.3-1.7-2-2.5c-0.3-0.3-0.5-0.6-0.8-0.9L58,3.2l0.9-0.5c0.5-0.3,1.1-0.1,1.5,0.1C60.9,3.1,61.2,3.4,61.5,3.9z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M70,80.9c-9.2,2.2-14.8,3.5-16.7,4l0.1,0l1.2-0.7v0l0.6-0.3c0.3-0.2,1.6-0.4,2-0.5c0.2-0.1,0.5-0.1,0.7-0.2 c0.2-0.1,0.5-0.1,0.7-0.2h0c0.2-0.1,0.5-0.1,0.7-0.2c0.9-0.2,1.8-0.4,2.7-0.6c0.3-0.1,0.7-0.2,1-0.2c0.2,0,0.3-0.1,0.5-0.1 c2.7-0.7,5.5-1.3,8.2-1.9c1.6-0.4,6.1-1.5,8.1-1.6c0.1,0,0.2,0,0.2,0c1.7,0,2.6,0.9,2.8,2.5c0.1,0.6,0.1,1.5,0,2.1 c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.4-0.6,0.7-1.1,1l-1.8,1.1c0.6-0.3,1-0.6,1.1-1.3c0.1-0.4,0.1-1.4,0.1-1.8c-0.1-1.2-0.4-2.5-1.7-2.9 c-1.1-0.4-3.6,0.2-4.6,0.4C73,80.2,71.5,80.6,70,80.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.7532,
    y1: 61.5012,
    x2: 111.2045,
    y2: 67.7276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4182,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5058,
    style: {
      stopColor: "#C0C0C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6006,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7998,
    style: {
      stopColor: "#7F7F7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9013,
    style: {
      stopColor: "#585858"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B2B2B"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M79.7,78.3l29.2-16.9l2.8-1.6l0.9-0.5l6.2-3.6l16-9.3c0.6-0.3,1.3,0,1.8,0.3c0.5,0.4,0.9,0.8,1.2,1.4 c0.3,0.6,0.5,1.1,0.6,1.8c0.1,0.6,0,1.4-0.6,1.7l-2.8,1.6c0,0,0,0,0,0L82.6,83.6c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.6,0.1-1.5,0-2.1 c-0.2-1.6-1-2.6-2.8-2.5C79.9,78.3,79.8,78.3,79.7,78.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M139.2,45c1.4,0.4,1.6,1.6,1.7,2.8c0,0.4,0,1.3-0.1,1.7c-0.2,0.6-0.5,1-1,1.4l-0.5,0.3l-1.8,1.1 c0.1-0.1,0.2-0.1,0.3-0.2c0.4-0.3,0.7-0.6,0.9-1.1c0.1-0.5,0.1-1.6,0.1-2.1c-0.1-0.7-0.3-1.6-0.8-2.2c-0.4-0.4-0.8-0.6-1.3-0.6 c-1-0.1-2,0.1-2.9,0.2c-1.5,0.3-2.9,0.6-4.4,0.9c-5.8,1.3-11.6,2.7-17.3,4.1c-0.1,0-0.2-0.1-0.2-0.1l1.3-0.7l0.2-0.1 c0.1-0.1,0.2-0.1,0.4-0.1c4.3-1,8.5-2,12.8-3c2.1-0.5,4.3-1,6.4-1.5c1.1-0.2,2.1-0.5,3.2-0.7C136.8,45,138.2,44.7,139.2,45 L139.2,45z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M58.6,1.2l1.9-1.1l0.1,0c0.6-0.3,1.2,0,1.7,0.4l0,0c1.4,1.2,5.5,7,6.6,8.5c2.1,2.9,4.2,5.8,6.3,8.7 c4.2,5.8,8.3,11.6,12.5,17.4c0.6,0.9,1.1,2.1,1,3.2l-3.2-1.9c-0.5-0.7-1-1.5-1.6-2.2c-0.6-0.9-1.2-1.7-1.8-2.6 c-1.1-1.6-2.3-3.2-3.4-4.7c-2.3-3.2-4.5-6.3-6.8-9.5c-2.3-3.2-4.6-6.3-6.9-9.5c-1.1-1.5-2.1-2.9-3.3-4.3c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.5-0.7-1.1-1.4-1.9-1.9C59.3,1.3,58.9,1.1,58.6,1.2z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M28,74.7L28,74.7c0.1-0.1,0.3-0.3,0.4-0.5c0.4-0.7,0.3-1.5,0.1-2.2c-0.1-0.5-0.3-0.9-0.5-1.3 c-0.3-0.7-0.8-1.3-1.3-1.9c-1.2-1.6-2.3-3.2-3.5-4.9c-2.3-3.2-4.7-6.5-7-9.7c-2.3-3.2-4.7-6.5-7-9.7c-1.2-1.6-2.3-3.2-3.5-4.8 c-0.8-1.1-1.6-2.2-2.5-3.2C3,35.9,2.6,35.4,2,35c-0.3-0.2-0.8-0.6-1.2-0.4l1.9-1.1c0.4-0.3,1,0.2,1.3,0.4c0.1,0.1,0.2,0.2,0.3,0.3 c0,0,0,0,0,0c0.3,0.3,0.6,0.6,0.8,0.9c0.7,0.8,1.3,1.6,2,2.5c0.3,0.4,0.7,0.9,1,1.4c0.9,1.2,1.8,2.5,2.7,3.7 c2.4,3.4,4.9,6.8,7.3,10.1c2.4,3.4,4.9,6.8,7.3,10.2c0.6,0.9,1.2,1.7,1.9,2.6c0.1,0.1,0.1,0.1,0.2,0.2h0c0.5,0.8,1.1,1.5,1.6,2.3 c0.4,0.6,0.8,1.1,1.1,1.8c0.2,0.5,0.4,1,0.4,1.5c0.1,0.8,0,1.8-0.8,2.3L29.2,74L28,74.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.5591,
    y1: 91.8625,
    x2: 66.5591,
    y2: 79.4031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1098,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4208,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M56.5,91.8c-1.7,0.3-3.1-1.3-3.8-2.5c-0.4-0.8-0.6-1.5-0.6-2.3c0-0.8,0.4-1.6,1.1-2c1.9-0.5,7.5-1.8,16.7-4 c1.5-0.4,3-0.7,4.6-1c1-0.2,3.5-0.8,4.6-0.4c1.3,0.4,1.6,1.8,1.7,2.9c0,0.4,0,1.4-0.1,1.8c-0.2,0.7-0.6,1-1.1,1.3l0,0 C76.1,87.7,60.4,91.1,56.5,91.8L56.5,91.8z M54.8,90.4l0.5-0.3c0.3-0.2,0.4-0.6,0.3-0.9c0-0.4-0.2-0.7-0.3-1 c-0.2-0.3-0.4-0.6-0.7-0.8c-0.2-0.2-0.6-0.4-1-0.2l-0.6,0.3c0,0,0,0,0,0c-0.1,0-0.1,0.1-0.2,0.2c-0.4,0.5,0,1.5,0.3,1.9 c0.2,0.3,0.4,0.5,0.7,0.7C54.2,90.5,54.5,90.6,54.8,90.4L54.8,90.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.2673,
    y1: 55.774,
    x2: 125.2673,
    y2: 46.0444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1697,
    style: {
      stopColor: "#585858"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    style: {
      stopColor: "#7F7F7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6864,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8495,
    style: {
      stopColor: "#C0C0C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M138.6,48.9c0.1,0.5,0.1,1.6-0.1,2.1c-0.1,0.5-0.4,0.8-0.9,1.1c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.8,0.5-1.6,0.8-2.5,1l2.8-1.6c0.6-0.3,0.7-1.1,0.6-1.7c-0.1-0.7-0.3-1.2-0.6-1.8c-0.3-0.6-0.7-1-1.2-1.4 c-0.5-0.3-1.2-0.7-1.8-0.3l-16,9.3v0l-4.8-2.8c-0.5-0.6-1.2-1.3-2-1.6c5.8-1.4,11.5-2.8,17.3-4.1c1.4-0.3,2.9-0.7,4.4-0.9 c0.9-0.2,2-0.4,2.9-0.2c0.5,0.1,0.9,0.3,1.3,0.6C138.4,47.3,138.6,48.1,138.6,48.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.8583,
    y1: 36.5305,
    x2: 72.8583,
    y2: 3.7425
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1697,
    style: {
      stopColor: "#585858"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    style: {
      stopColor: "#7F7F7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6864,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8495,
    style: {
      stopColor: "#C0C0C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M83.9,34.3c0.5,0.7,1.1,1.4,1.6,2.2l-0.7-0.4c-0.7-0.8-1.9-2-3.2-1.9L75.8,31c-3.8-5.2-12-16.7-15.5-22.1 l1.6-0.9c0.4-0.2,0.6-0.7,0.6-1.2c0.1-1-0.4-2.1-1-2.9l0.1-0.1c1.1,1.4,2.2,2.9,3.3,4.3c2.3,3.1,4.6,6.3,6.9,9.5 c2.3,3.2,4.6,6.3,6.8,9.5c1.1,1.6,2.3,3.2,3.4,4.7C82.6,32.6,83.2,33.5,83.9,34.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.3737,
    y1: 75.0019,
    x2: 14.3737,
    y2: 34.5141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1098,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4208,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4C4C4"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M25.8,74.7c-0.7-0.3-1.2-0.8-1.7-1.5c0,0,0,0,0,0l0,0c-4.6-6.2-9.1-12.5-13.6-18.8c-2.2-3.2-4.5-6.3-6.6-9.5 c-0.9-1.3-2.3-3.5-3.1-4.9C0.2,39,0,38.4,0,37.3c0-0.8-0.1-2.2,0.8-2.7h0c0.4-0.2,1,0.2,1.2,0.4c0.5,0.4,0.9,0.9,1.3,1.4 c0.9,1,1.7,2.1,2.5,3.2c1.2,1.6,2.4,3.2,3.5,4.8c2.3,3.2,4.7,6.5,7,9.7c2.3,3.2,4.7,6.5,7,9.7c1.2,1.6,2.3,3.2,3.5,4.9 c0.4,0.6,0.9,1.2,1.3,1.9c0.2,0.4,0.4,0.9,0.5,1.3c0.2,0.7,0.2,1.6-0.1,2.2c-0.1,0.2-0.3,0.4-0.5,0.5l0,0 C27.3,75.1,26.4,75.1,25.8,74.7z M25.1,73.6c0.2,0,0.3,0,0.4-0.1c0,0,0,0,0,0l0.6-0.3c0.5-0.3,0.3-1.1,0.2-1.5 c-0.2-0.4-0.4-0.7-0.7-1c-0.3-0.2-0.7-0.5-1.1-0.3l-0.5,0.3l0,0c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.4,0,0.7,0.1,1 C23.9,72.8,24.5,73.6,25.1,73.6z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M25.5,73.6C25.5,73.6,25.5,73.6,25.5,73.6c-0.1,0.1-0.3,0.1-0.4,0.1c-0.7-0.1-1.2-0.9-1.4-1.4 c-0.1-0.3-0.2-0.6-0.1-1c0-0.2,0.2-0.4,0.4-0.5c0.1,0,0.2-0.1,0.3,0c0.7,0.1,1.2,0.9,1.4,1.4c0.1,0.3,0.2,0.6,0.1,1 C25.8,73.3,25.7,73.5,25.5,73.6z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M54.8,90.4c-0.2,0.2-0.5,0.1-0.8,0c-0.3-0.2-0.5-0.4-0.7-0.7c-0.3-0.4-0.7-1.4-0.3-1.9 c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0c0.2-0.1,0.5,0,0.7,0.1c0.3,0.2,0.5,0.4,0.7,0.7c0.3,0.4,0.7,1.4,0.3,1.9 C54.8,90.3,54.8,90.4,54.8,90.4z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M55.6,89.2c0,0.3,0,0.7-0.3,0.9l-0.5,0.3l0,0c0,0,0.1-0.1,0.1-0.1c0.4-0.6,0-1.5-0.3-1.9 c-0.2-0.3-0.4-0.5-0.7-0.7c-0.2-0.1-0.5-0.2-0.7-0.1l0.6-0.3c0.3-0.2,0.7,0,1,0.2c0.3,0.2,0.5,0.5,0.7,0.8 C55.5,88.5,55.6,88.8,55.6,89.2z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M26.3,71.7c0.2,0.4,0.3,1.2-0.2,1.5l-0.6,0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0-0.7-0.1-1 c-0.2-0.5-0.7-1.3-1.4-1.4c-0.1,0-0.2,0-0.3,0l0,0l0.5-0.3c0.4-0.2,0.9,0.1,1.1,0.3C25.9,71,26.1,71.3,26.3,71.7z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M32.5,71c0.2,0.6,0.3,1.8-0.4,2.2l-1.2,0.7c0.3-0.2,0.6-0.5,0.8-1c0.3-0.9,0.1-2.1-0.2-2.9 c-0.6-1.6-2.1-3.8-4-4.1h0c-0.1-0.1-0.1-0.1-0.2-0.2c1-0.1,1.9,0.2,2.6,1c0.7,0.7,1.2,1.5,1.7,2.3C31.9,69.5,32.3,70.2,32.5,71z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M58.6,83c-0.2,0.1-0.5,0.1-0.7,0.2c-0.8-0.5-1.6-0.7-2.2-0.4c0,0-0.1,0-0.1,0l0.2-0.1v0 C56.7,82.1,57.9,82.5,58.6,83z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M55.7,82.7c0.6-0.2,1.4-0.1,2.2,0.4c-0.2,0.1-0.5,0.1-0.7,0.2c-0.4,0.1-1.7,0.3-2,0.5l-0.6,0.3 C54.7,83.4,55.1,83,55.7,82.7C55.6,82.7,55.7,82.7,55.7,82.7z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M61.3,80.7c0.7,0.3,1.2,0.7,1.6,1.3c-0.3,0.1-0.7,0.2-1,0.2l-2.7-1.5l0,0C59.9,80.2,60.7,80.4,61.3,80.7z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M30.1,63.8c0.9-0.5,2,0,2.7,0.5c0.8,0.6,1.4,1.3,1.9,2.2L30.1,63.8L30.1,63.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.1287,
    y1: 71.8732,
    x2: 30.8012,
    y2: 68.2007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2926,
    style: {
      stopColor: "#B9B9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8199,
    style: {
      stopColor: "#D9D9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E6"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M30.8,73.9c-0.4,0.3-1,0.3-1.6,0.1l0.6-0.3c0.8-0.5,0.9-1.6,0.8-2.3c-0.1-0.5-0.2-1-0.4-1.5 c-0.3-0.7-0.7-1.2-1.1-1.8c-0.5-0.8-1.1-1.5-1.6-2.3c1.9,0.3,3.5,2.6,4,4.1c0.3,0.9,0.5,2,0.2,2.9C31.5,73.3,31.2,73.7,30.8,73.9 C30.9,73.9,30.9,73.9,30.8,73.9z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M80.3,40.6c0.2,0.4,0.3,1.2-0.2,1.5l-0.7,0.4c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.4,0-0.7-0.1-1 c-0.2-0.5-0.8-1.3-1.4-1.4c-0.1,0-0.2,0-0.3,0l0,0l0.7-0.4c0.4-0.2,0.9,0.1,1.1,0.3C79.9,39.8,80.1,40.2,80.3,40.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.2729,
    y1: 42.6533,
    x2: 81.2676,
    y2: 38.6586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2926,
    style: {
      stopColor: "#B9B9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8199,
    style: {
      stopColor: "#D9D9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E6"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M77.2,42.4c-0.5-0.8-0.9-1.7-1.1-2.6c-0.2-0.9-0.2-2,0.5-2.8c0.1-0.2,0.3-0.3,0.5-0.4 c0.7-0.3,1.5-0.1,2.2,0.3c0.9,0.5,1.5,1.2,2,2c0.5,0.8,0.9,1.7,1.1,2.6c0.2,0.9,0.2,2-0.5,2.7c-0.1,0.1-0.2,0.2-0.4,0.3 c-0.7,0.4-1.6,0.2-2.3-0.2C78.4,43.9,77.8,43.2,77.2,42.4z M79.4,42.5l0.7-0.4c0.5-0.3,0.3-1.1,0.2-1.5c-0.2-0.4-0.4-0.7-0.7-1 c-0.3-0.2-0.7-0.5-1.1-0.3l-0.7,0.4l0,0c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.4,0,0.7,0.1,1c0.2,0.5,0.7,1.3,1.4,1.4 C79.1,42.6,79.3,42.5,79.4,42.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.2804,
    y1: 59.3016,
    x2: 110.2571,
    y2: 55.325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2926,
    style: {
      stopColor: "#B9B9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8199,
    style: {
      stopColor: "#D9D9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E6"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M106.3,53.5C106.3,53.5,106.3,53.5,106.3,53.5c0.7-0.3,1.5-0.1,2.3,0.4c1.1,0.7,2,1.9,2.5,3.1 c0.4,0.9,0.7,1.9,0.5,2.9l-2.8,1.6c-2.2-0.9-4.2-4.4-3.6-6.7C105.5,54.1,105.9,53.7,106.3,53.5z M108.6,59.3l0.7-0.4 c0.3-0.2,0.4-0.6,0.3-0.9c0-0.4-0.2-0.7-0.3-1c-0.2-0.3-0.4-0.6-0.7-0.8c-0.2-0.2-0.6-0.4-1-0.2l-0.7,0.4c0,0,0,0,0,0 c-0.1,0-0.1,0.1-0.2,0.2c-0.4,0.6,0,1.5,0.3,1.9c0.2,0.3,0.4,0.5,0.7,0.7C108.1,59.4,108.4,59.5,108.6,59.3L108.6,59.3z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M109.6,58c0,0.3,0,0.7-0.3,0.9l-0.7,0.4l0,0c0,0,0.1-0.1,0.1-0.1c0.4-0.5,0-1.5-0.3-1.9 c-0.2-0.3-0.4-0.5-0.7-0.7c-0.2-0.1-0.5-0.2-0.7-0.1l0.7-0.4c0.3-0.2,0.7,0,1,0.2c0.3,0.2,0.5,0.5,0.7,0.8 C109.5,57.3,109.6,57.6,109.6,58z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M108.6,59.3c-0.2,0.2-0.5,0.1-0.8,0c-0.3-0.2-0.5-0.4-0.7-0.7c-0.3-0.4-0.7-1.4-0.3-1.9 c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0c0.2-0.1,0.5,0,0.7,0.1c0.3,0.2,0.5,0.4,0.7,0.7c0.3,0.4,0.7,1.4,0.3,1.9 C108.7,59.2,108.6,59.3,108.6,59.3z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M79.4,42.5c-0.1,0.1-0.3,0.1-0.4,0.1c-0.7-0.1-1.2-0.8-1.4-1.4c-0.1-0.3-0.2-0.6-0.1-1c0-0.3,0.2-0.4,0.4-0.5 c0.1,0,0.2-0.1,0.3,0c0.7,0.1,1.2,0.8,1.4,1.4c0.1,0.3,0.2,0.6,0.1,1C79.6,42.2,79.5,42.4,79.4,42.5z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M58,3.2c0-0.4,0-1.7,0.5-2c0.3-0.2,0.7,0.1,1,0.2c0.7,0.5,1.3,1.3,1.9,1.9c0.1,0.1,0.2,0.2,0.3,0.3l-0.1,0.1 c-0.3-0.4-0.7-0.8-1.1-1c-0.4-0.2-1-0.4-1.5-0.1L58,3.2z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8697 -0.4936 0.4936 0.8697 -5.8399 19.2268)",
    className: "st62",
    cx: 33.5,
    cy: 20.7,
    rx: 28,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M32.1,18.2c4.1-2.3,8.9-4.9,12.3-6.5c2.2-1.1,4.6-2.2,6.3-2.9c3.5-1.4,6.2-2.2,6.5-1.6 c0.3,0.6-1.7,2.5-4.8,4.8c-1.5,1.1-3.7,2.6-5.8,4c-3.2,2.1-7.8,4.9-12,7.2c-4.1,2.3-8.9,4.9-12.3,6.5c-2.2,1.1-4.6,2.2-6.3,2.9 c-3.5,1.4-6.2,2.2-6.5,1.6c-0.3-0.6,1.7-2.5,4.8-4.8c1.5-1.1,3.7-2.6,5.8-4C23.3,23.4,28,20.6,32.1,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M32.2,18.4c3.7-2.1,8.9-4.9,12-6.4c2-1,4.6-2.2,6.2-2.9c3.2-1.3,6.1-2.3,6.4-1.7c0.3,0.5-2,2.5-4.7,4.6 c-1.3,1-3.8,2.6-5.6,3.8c-2.9,1.9-8,4.9-11.7,7c-3.7,2.1-8.9,4.9-12,6.4c-2,1-4.6,2.2-6.2,2.9c-3.2,1.3-6.1,2.3-6.4,1.7 c-0.3-0.5,2-2.5,4.7-4.6c1.3-1,3.8-2.6,5.6-3.8C23.4,23.6,28.5,20.5,32.2,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M32.3,18.6c3.3-1.9,9-4.9,11.7-6.3c1.8-0.9,4.6-2.3,6-2.8c2.8-1.1,5.9-2.3,6.2-1.8c0.3,0.5-2.3,2.5-4.7,4.4 c-1.2,0.9-3.9,2.6-5.5,3.7c-2.6,1.7-8.1,5-11.4,6.9c-3.3,1.9-9,4.9-11.7,6.3c-1.8,0.9-4.6,2.3-6,2.8c-2.8,1.1-5.9,2.3-6.2,1.8 C10.4,33,13,31,15.4,29.1c1.2-0.9,3.9-2.6,5.5-3.7C23.5,23.8,29,20.5,32.3,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M32.4,18.8c2.9-1.6,9-5,11.4-6.1c1.5-0.8,4.6-2.3,5.8-2.8c2.5-1,5.7-2.3,6-1.9c0.2,0.4-2.6,2.6-4.7,4.2 c-1,0.8-4,2.6-5.4,3.6c-2.2,1.5-8.2,5-11.1,6.7c-2.9,1.6-9,5-11.4,6.1c-1.5,0.8-4.6,2.3-5.8,2.8c-2.5,1-5.7,2.3-6,1.9 c-0.2-0.4,2.6-2.6,4.7-4.2c1-0.8,4-2.6,5.4-3.6C23.5,24,29.5,20.4,32.4,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M32.5,19c2.5-1.4,9.1-5,11.1-6c1.3-0.6,4.6-2.4,5.7-2.8c2.1-0.9,5.6-2.3,5.8-2c0.2,0.4-2.9,2.6-4.7,4 c-0.9,0.7-4.1,2.6-5.3,3.4c-1.9,1.3-8.4,5.1-10.8,6.5c-2.5,1.4-9.1,5-11.1,6c-1.3,0.6-4.6,2.4-5.7,2.8c-2.1,0.9-5.6,2.3-5.8,2 c-0.2-0.4,2.9-2.6,4.7-4c0.9-0.7,4.1-2.6,5.3-3.4C23.6,24.2,30,20.4,32.5,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M32.6,19.2c2.1-1.2,9.1-5,10.8-5.8c1.1-0.5,4.6-2.4,5.5-2.7c1.8-0.7,5.4-2.4,5.6-2.1 c0.2,0.3-3.1,2.6-4.7,3.8c-0.7,0.6-4.1,2.6-5.2,3.3c-1.6,1-8.5,5.1-10.6,6.3c-2.1,1.2-9.1,5-10.8,5.8c-1.1,0.5-4.6,2.4-5.5,2.7 c-1.8,0.7-5.4,2.4-5.6,2.1c-0.2-0.3,3.1-2.6,4.7-3.8c0.7-0.6,4.1-2.6,5.2-3.3C23.7,24.4,30.6,20.3,32.6,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M32.7,19.3c1.7-0.9,9.1-5,10.5-5.7c0.9-0.4,4.6-2.4,5.3-2.7c1.4-0.6,5.3-2.4,5.4-2.1 c0.1,0.2-3.4,2.7-4.6,3.6c-0.6,0.4-4.2,2.6-5.1,3.2c-1.3,0.8-8.6,5.2-10.3,6.1c-1.7,0.9-9.1,5-10.5,5.7c-0.9,0.4-4.6,2.4-5.3,2.7 c-1.4,0.6-5.3,2.4-5.4,2.1c-0.1-0.2,3.4-2.6,4.6-3.6c0.6-0.4,4.2-2.6,5-3.2C23.7,24.6,31.1,20.3,32.7,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M32.8,19.5C34.1,18.8,42,14.5,43,14c0.7-0.3,4.6-2.5,5.1-2.7c1.1-0.4,5.1-2.4,5.2-2.2 c0.1,0.2-3.7,2.7-4.6,3.4c-0.4,0.3-4.3,2.6-4.9,3.1c-1,0.6-8.8,5.2-10,5.9c-1.2,0.7-9.2,5.1-10.2,5.6c-0.7,0.3-4.6,2.5-5.1,2.7 c-1.1,0.4-5.1,2.4-5.2,2.2c-0.1-0.2,3.7-2.7,4.6-3.4c0.4-0.3,4.3-2.6,4.9-3.1C23.8,24.8,31.6,20.2,32.8,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M33,19.7c0.8-0.5,9.2-5.1,9.9-5.4c0.4-0.2,4.6-2.5,5-2.6c0.7-0.3,5-2.4,5.1-2.3c0.1,0.1-4,2.7-4.6,3.2 c-0.3,0.2-4.4,2.7-4.8,2.9c-0.6,0.4-8.9,5.2-9.7,5.7c-0.8,0.5-9.2,5.1-9.9,5.4c-0.4,0.2-4.6,2.5-5,2.6c-0.7,0.3-5,2.4-5.1,2.3 c-0.1-0.1,4-2.7,4.6-3.2c0.3-0.2,4.4-2.7,4.8-2.9C23.9,25,32.1,20.2,33,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M33.1,19.9c0.4-0.2,9.2-5.1,9.6-5.3c0.2-0.1,4.6-2.5,4.8-2.6c0.4-0.1,4.8-2.5,4.9-2.4c0,0.1-4.3,2.7-4.6,3 c-0.1,0.1-4.5,2.7-4.7,2.8c-0.3,0.2-9,5.3-9.4,5.5c-0.4,0.2-9.2,5.1-9.6,5.3c-0.2,0.1-4.6,2.5-4.8,2.6c-0.4,0.1-4.8,2.5-4.9,2.4 c0-0.1,4.3-2.7,4.6-3c0.1-0.1,4.5-2.7,4.7-2.8C23.9,25.2,32.6,20.1,33.1,19.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "14.9,30.8 19.4,28.1 24,25.4 33.2,20.1 42.4,15 47.1,12.4 51.8,9.9 47.2,12.7 42.6,15.3 33.5,20.6  24.2,25.8 19.6,28.4  "
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.872 -0.4895 0.4895 0.872 -17.6821 61.9332)",
    className: "st62",
    cx: 109.6,
    cy: 64.8,
    rx: 28.5,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M108.2,62.3c4.2-2.4,9.1-4.9,12.6-6.6c2.3-1.1,4.7-2.2,6.5-2.9c3.6-1.5,6.3-2.3,6.6-1.7 c0.3,0.6-1.8,2.5-4.9,4.8c-1.5,1.1-3.8,2.6-5.9,4c-3.3,2.1-8,4.9-12.2,7.3c-4.2,2.4-9.1,4.9-12.6,6.6c-2.3,1.1-4.7,2.2-6.5,2.9 c-3.6,1.5-6.3,2.3-6.6,1.7c-0.3-0.6,1.8-2.5,4.9-4.8c1.5-1.1,3.8-2.6,5.9-4C99.3,67.5,104,64.7,108.2,62.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M108.3,62.5c3.8-2.1,9.1-5,12.3-6.5c2-1,4.7-2.3,6.3-2.9c3.2-1.3,6.2-2.3,6.5-1.8c0.3,0.5-2.1,2.5-4.9,4.6 c-1.4,1-3.9,2.6-5.8,3.9c-2.9,1.9-8.1,5-11.9,7.1c-3.8,2.1-9.1,5-12.3,6.5c-2,1-4.7,2.3-6.3,2.9c-3.2,1.3-6.2,2.3-6.5,1.8 c-0.3-0.5,2.1-2.5,4.9-4.6c1.4-1,3.9-2.6,5.8-3.9C99.3,67.7,104.5,64.6,108.3,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M108.4,62.7c3.4-1.9,9.2-5,12-6.3c1.8-0.9,4.7-2.3,6.1-2.9c2.9-1.2,6-2.3,6.3-1.8c0.3,0.5-2.4,2.6-4.8,4.4 c-1.2,0.9-4,2.6-5.6,3.7c-2.6,1.7-8.3,5-11.6,6.9c-3.4,1.9-9.2,5-12,6.3c-1.8,0.9-4.7,2.3-6.1,2.9c-2.9,1.2-6,2.3-6.3,1.8 c-0.3-0.5,2.4-2.6,4.8-4.4c1.2-0.9,4-2.6,5.6-3.7C99.4,67.9,105,64.6,108.4,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M108.5,62.9c2.9-1.7,9.2-5,11.6-6.2c1.6-0.8,4.7-2.3,5.9-2.8c2.5-1,5.9-2.3,6.1-1.9 c0.2,0.4-2.6,2.6-4.8,4.2c-1.1,0.8-4,2.6-5.5,3.6c-2.3,1.5-8.4,5.1-11.3,6.7c-2.9,1.7-9.2,5-11.6,6.2c-1.6,0.8-4.7,2.3-5.9,2.8 c-2.5,1-5.9,2.3-6.1,1.9c-0.2-0.4,2.6-2.6,4.8-4.2c1.1-0.8,4-2.6,5.5-3.6C99.5,68.1,105.6,64.5,108.5,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M108.6,63.1c2.5-1.4,9.2-5,11.3-6c1.4-0.7,4.7-2.4,5.8-2.8c2.1-0.9,5.7-2.4,5.9-2c0.2,0.4-2.9,2.6-4.8,4 c-0.9,0.7-4.1,2.7-5.4,3.5c-2,1.3-8.5,5.1-11.1,6.5c-2.5,1.4-9.2,5-11.3,6c-1.4,0.7-4.7,2.4-5.8,2.8c-2.1,0.9-5.7,2.4-5.9,2 c-0.2-0.4,2.9-2.6,4.8-4c0.9-0.7,4.1-2.7,5.4-3.5C99.5,68.3,106.1,64.5,108.6,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M108.7,63.3c2.1-1.2,9.3-5.1,11-5.9c1.1-0.5,4.7-2.4,5.6-2.8c1.8-0.7,5.5-2.4,5.7-2.1 c0.2,0.3-3.2,2.6-4.8,3.8c-0.8,0.6-4.2,2.7-5.3,3.3c-1.6,1.1-8.7,5.2-10.8,6.3c-2.1,1.2-9.3,5.1-11,5.9c-1.1,0.5-4.7,2.4-5.6,2.8 c-1.8,0.7-5.5,2.4-5.7,2.1c-0.2-0.3,3.2-2.6,4.8-3.8c0.8-0.6,4.2-2.7,5.3-3.3C99.6,68.5,106.6,64.4,108.7,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M108.8,63.4c1.7-0.9,9.3-5.1,10.7-5.8c0.9-0.4,4.7-2.4,5.4-2.7c1.4-0.6,5.4-2.4,5.5-2.2 c0.1,0.2-3.5,2.7-4.7,3.6c-0.6,0.4-4.3,2.7-5.2,3.2c-1.3,0.8-8.8,5.2-10.5,6.1c-1.7,0.9-9.3,5.1-10.7,5.8 c-0.9,0.4-4.7,2.4-5.4,2.7c-1.4,0.6-5.4,2.4-5.5,2.2c-0.1-0.2,3.5-2.7,4.7-3.6c0.6-0.4,4.3-2.7,5.2-3.2 C99.7,68.7,107.2,64.4,108.8,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M108.9,63.6c1.3-0.7,9.3-5.1,10.4-5.6c0.7-0.3,4.7-2.5,5.3-2.7c1.1-0.4,5.2-2.4,5.3-2.3 c0.1,0.2-3.8,2.7-4.7,3.4c-0.5,0.3-4.4,2.7-5,3.1c-1,0.6-8.9,5.2-10.2,6c-1.3,0.7-9.3,5.1-10.4,5.6c-0.7,0.3-4.7,2.5-5.3,2.7 c-1.1,0.4-5.2,2.4-5.3,2.3c-0.1-0.2,3.8-2.7,4.7-3.4c0.5-0.3,4.4-2.7,5-3.1C99.7,69,107.7,64.3,108.9,63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M109.1,63.8c0.8-0.5,9.4-5.1,10.1-5.5c0.5-0.2,4.7-2.5,5.1-2.7c0.7-0.3,5.1-2.5,5.2-2.3 c0.1,0.1-4.1,2.7-4.7,3.2c-0.3,0.2-4.5,2.7-4.9,2.9c-0.7,0.4-9.1,5.3-9.9,5.8c-0.8,0.5-9.4,5.1-10.1,5.5 c-0.5,0.2-4.7,2.5-5.1,2.7c-0.7,0.3-5.1,2.5-5.2,2.3c-0.1-0.1,4.1-2.7,4.7-3.2c0.3-0.2,4.5-2.7,4.9-2.9 C99.8,69.2,108.2,64.3,109.1,63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M109.2,64c0.4-0.2,9.4-5.2,9.8-5.3c0.2-0.1,4.7-2.6,4.9-2.6c0.4-0.1,4.9-2.5,5-2.4c0,0.1-4.3,2.7-4.7,3 c-0.2,0.1-4.6,2.7-4.8,2.8c-0.3,0.2-9.2,5.3-9.6,5.6c-0.4,0.2-9.4,5.2-9.8,5.3c-0.2,0.1-4.7,2.6-4.9,2.6c-0.4,0.1-4.9,2.5-5,2.4 c0-0.1,4.3-2.7,4.7-3c0.2-0.1,4.6-2.7,4.8-2.8C99.8,69.4,108.7,64.2,109.2,64z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "90.6,75 95.2,72.3 99.9,69.6 109.3,64.2 118.7,59 123.5,56.4 128.2,53.9 123.6,56.7 118.9,59.4  109.6,64.7 100.1,69.9 95.4,72.5  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.d22513352807a50fe505c6e02d1c3966.svg";
export { ForwardRef as ReactComponent };